<template>
  <div class="task-content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="header">
      <div class="back" @click="$router.go(-1)">返回</div>
      <div class="task-title">
        {{ taskTitle && newTaskTitleTxt ? taskTitle + '(' + newTaskTitleTxt + ')' : taskTitle || '配置任务包' }}
        <span v-if="taskTitle && !disabled" @click="visible7 = true">修改</span>
      </div>
    </div>
    <template v-if="detail.bizApproveVO && detail.bizApproveVO.approveGuid">
      <div class="title">申请信息</div>
      <div class="approve-item-list">
        <div class="item">
          <div class="label">
            申请人：
          </div>
          <div class="value">
            {{ detail.bizApproveVO.staffName }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            所在部门：
          </div>
          <div class="value">
            {{ detail.bizApproveVO.organisationName }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            提交时间：
          </div>
          <div class="value">
            {{ detail.bizApproveVO.createTime | getTimeDate }}
          </div>

        </div>
        <img v-if="detail.bizApproveVO.approveState == 'C'" src="../../assets/images/ic_cancel.png" />
        <img v-if="detail.bizApproveVO.approveState == 'Y'" src="../../assets/images/ic_pass.png" />
        <img v-if="detail.bizApproveVO.approveState == 'A'" src="../../assets/images/ic_shenping.png" />
        <img v-if="detail.bizApproveVO.approveState == 'R'" src="../../assets/images/ic_reject.png" />

      </div>

    </template>


    <div class="title">基本配置</div>
    <el-form label-width="100px" label-position="right" class="demo-ruleForm">
      <!-- 基本配置 开始 -->
      <div class="basic-conetent">
        <div :style="disabled ? 'display:flex;width:850px;' : 'display:flex;width:800px;padding-left:20px;'">
          <!-- 委托方 开始 -->
          <el-form-item style="width: 400px">
            <span slot="label" style="color: red">*</span>
            <span slot="label">委托方<span style="display: inline-block; width: 4px"></span></span>
            <el-select style="width: 300px; margin-left: 10px" v-model="sendTenantName" @change="changeSendTenant"
              filterable placeholder="请选择委托方" v-if="!disabled">
              <el-option v-for="(item, index) in sendTenantList" :key="index" :label="item.sendTenantName"
                :value="item.sendTenantName"></el-option>
            </el-select>
            <div :title="sendTenantName" class="content-name" v-else>{{ sendTenantName }}</div>
          </el-form-item>
          <!-- 委托方 结束 -->

          <!-- 服务商 开始  -->
          <el-form-item style="padding-left: 15px">
            <span slot="label" style="color: red">*</span>
            <span slot="label">服务商<span style="display: inline-block; width: 6px"></span></span>
            <div :title="serviceTenantName" class="content-name" style="margin-left: 10px">{{ serviceTenantName }}</div>
            <div></div>
          </el-form-item>
          <!-- 服务商 结束  -->
        </div>
        <div class="task-model" v-if="taskPriceModel==2&&!disabled">当前价格模式：区间价</div>

        <div style="display: flex">
          <!-- 发布人员 开始 -->
          <div class="management-list" style="width: 400px">
            <div class="management-name"><span style="color: red">*</span>发布人员</div>
            <div style="text-align: left">
              <span class="designee" v-show="departmentData !== '' || departmentData !== null"
                v-for="(item, index) in departmentData" :key="index"><span class="select-name">{{ item.staffName
                }}</span>
                <span v-if="!disabled" @click="delDepartmentSingle(index)"
                  class="ml10 cursor-sty font-S19">×</span></span>
              <span class="select-department" v-if="!disabled" @click="addPeople">{{
                departmentData && departmentData.length > 0 ? '修改' : '指定人员'
              }}</span>
            </div>
          </div>
          <!-- 发布人员 结束 -->

          <!-- 执行部门 开始 -->
          <div class="base-info" :style="disabled ? '' : 'padding-left:20px;'">
            <div class="base-title"><span style="color: red">*</span>执行部门</div>
            <div class="depart-choose" @click="chooseDepartmentPerson" v-if="!disabled">
              <span v-if="departmentListII.length == 0" class="place-choose">请选择</span>
              <span class="place-show" v-else>{{ this.getDepartmentName(departmentListII) }}</span>
              
            </div>
            <div style="border: 0 none" class="depart-choose" v-else>
              {{ this.getDepartmentName(departmentListII) }} 
            </div>
          </div>
          <!-- 执行部门 结束 -->
        </div>
        <div style="display: flex;">
          <!-- 发布周期 开始-->
          <el-form-item :style="disabled ? 'padding-right:74px;' : 'padding-right:90px'">
            <span slot="label" style="color: red">*</span>
            <span slot="label">发布周期 </span>
            <el-radio-group v-model="timeType" :disabled="disabled">
              <el-radio label="按年">按年</el-radio>
              <el-radio label="按月">按月</el-radio>
              <el-radio label="自定义">自定义</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 发布周期 结束-->

          <!-- 执行日期 开始 -->
          <el-form-item style="width: 400px;"
            v-if="timeType == '按年' || timeType == '按月' || timeType == '自定义' || disabled">
            <span slot="label" style="color: red">*</span>
            <span slot="label">执行日期 </span>
            <div>{{ startTime || ' -' }} 至 {{ endTime || ' -' }}</div>
          </el-form-item>
          <!-- 执行日期 结束 -->
        </div>
        <div style="display: flex; width: 800px">
          <!-- 选择时间 开始 -->
          <el-form-item style="width: 400px; padding-left: 20px" v-if="timeType == '自定义' && !disabled">
            <span slot="label" style="color: red">*</span>
            <span slot="label">选择时间 </span>
            <el-date-picker v-model="timeRange" type="daterange" align="center" unlink-panels range-separator="至"
              start-placeholder="起始时间" end-placeholder="截止时间" value-format="yyyy-MM-dd" style="width: 300px; float: left"
              :clearable="false" :disabled="disabled" />
          </el-form-item>
          <el-form-item style="width: 400px; padding-left: 20px" v-if="timeType == '按年' && !disabled">
            <span slot="label" style="color: red">*</span>
            <span slot="label">选择时间 </span>
            <el-date-picker v-model="year" type="year" align="center" format="yyyy年" placeholder="请选择年份"
              style="width: 300px; float: left" value-format="yyyy" :clearable="false" :disabled="disabled" />
          </el-form-item>
          <el-form-item style="width: 400px; padding-left: 20px" v-if="timeType == '按月' && !disabled">
            <span slot="label" style="color: red">*</span>
            <span slot="label">选择时间 </span>
            <el-date-picker v-model="month" type="month" align="center" format="yyyy年MM月" placeholder="请选择核算月份"
              style="width: 300px; float: left" value-format="yyyy-MM" :clearable="false" :disabled="disabled" />
          </el-form-item>
          <!-- 选择时间 结束 -->

          <!-- 任务类型 开始 -->
          <el-form-item v-if="!disabled" :style="disabled ? '' : 'margin-left:20px'">
            <span slot="label" style="color: red">*</span>
            <span slot="label">任务类型</span>
            <el-select style="width: 300px; margin-left: 5px" v-model="taskType" filterable placeholder="请选择任务类型">
              <el-option v-for="(item, index) in getCodeListByKey('任务类型')" :key="index" :label="item.text"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- 任务类型 结束 -->
        </div>
        <div style="display: flex;">
          <!-- 智能预测 开始（数据标注类型不支持，隐藏） -->
          <el-form-item v-if="!isLabelTask" :style="disabled ? 'padding-right:20px;width: 400px' : ''">
            <span slot="label" style="color: red">*</span>
            <span slot="label">智能预测 </span>
            <el-radio-group v-model="autoForecastOpen" :disabled="disabled">
              <el-radio label="1">开启</el-radio>
              <el-radio label="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 智能预测 结束 -->
          <!-- 企业驳回原因 开始 -->
          <el-form-item style=" width: 400px" v-if="detail.approveSuggest&&disabled">
            <span slot="label">企业驳回原因<span style="display:inline-block;"></span></span>
            <div style="max-width:200px;text-align:left;">{{ detail.approveSuggest }}</div>
            <div></div>
          </el-form-item>
          <!-- 企业驳回原因 结束 -->
        </div>
      </div>
      <!-- 基本配置结束 -->

      <!-- 任务明细开始 -->
      <div class="title padding0">任务明细</div>
      <!-- 数据标注类型：标注配置区块（v26.3.3，替代传统任务模版明细） -->
      <div class="label-task-config" v-if="isLabelTask">
        <el-form label-width="120px" label-position="right" class="demo-ruleForm">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item>
                <span slot="label" style="color: red">*</span>
                <span slot="label">选择标注数据</span>
                <el-select v-model="labelForm.datasetGuids" placeholder="请选择数据集（仅待标注状态，可多选，须同一数据模态）" filterable
                  multiple collapse-tags style="width: 340px" :disabled="labelDisabled" @change="onDatasetChange">
                  <el-option v-for="item in datasetOptions" :key="item.guid"
                    :label="datasetLabel(item)" :value="item.guid"></el-option>
                </el-select>
                <div class="label-task-modal" v-if="labelForm.dataModalName">数据模态：{{ labelForm.dataModalName }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <span slot="label" style="color: red">*</span>
                <span slot="label">质检比例</span>
                <el-input v-model="labelForm.qcRatio" style="width: 120px" :disabled="labelDisabled" maxlength="3"
                  placeholder="0-100" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
                <span style="margin-left: 4px">%</span>
                <span class="label-task-tip">（抽检比例，默认 100）</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item>
                <span slot="label">模型选择</span>
                <el-select v-model="labelForm.modelGuid" placeholder="请选择预标注模型（选填）" filterable clearable
                  style="width: 300px" :disabled="labelDisabled" @change="onModelChange">
                  <el-option v-for="item in filteredModelOptions" :key="item.guid"
                    :label="item.modelName + '（' + item.labelTypeName + '）'" :value="item.guid"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <span slot="label" style="color: red">*</span>
                <span slot="label">选择标签</span>
                <!-- FOUR-3001：多下拉选择标签（每行一个标签模板+行内删除，可继续添加）；
                     v-model 数组下标赋值无响应，用 :value + $set -->
                <div class="label-snapshot-rows">
                  <div v-for="(snap, idx) in labelForm.labelSnapshots" :key="idx" class="label-snapshot-row">
                    <label-template-select :value="labelForm.labelSnapshots[idx]"
                      @input="(v) => $set(labelForm.labelSnapshots, idx, v)" :data-modal-guid="labelForm.dataModalGuid"
                      :disabled="labelDisabled" style="width: 300px"></label-template-select>
                    <el-button type="text" class="danger label-snapshot-del" :disabled="labelDisabled"
                      @click="labelForm.labelSnapshots.splice(idx, 1)">删除</el-button>
                  </div>
                  <el-button type="text" icon="el-icon-plus" size="mini" :disabled="labelDisabled"
                    @click="labelForm.labelSnapshots.push(null)">添加</el-button>
                  <div class="label-capacity-tip">已选{{ labelSelectionTemplateCount }}个模板，共{{ labelSelectionCount }}/{{ maxTaskLabels }}个标签</div>
                  <div v-if="$route.query.guid && labelSelectionCount > maxTaskLabels" class="label-capacity-tip">历史标签未修改时，提交由系统校验原快照</div>
                  <div v-if="originalLabelSnapshotInvalid" class="label-capacity-tip" style="color: #f56c6c">原任务标签快照格式异常，请核查原任务后重试</div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="label-task-subtitle">标注人员要求<span class="label-task-tip">（均非必填，下发时按此过滤候选人员）</span>
            <el-button type="text" size="mini" class="label-task-more-btn" @click="labelMoreVisible = true">更多</el-button>
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item>
                <span slot="label">所属科室</span>
                <el-cascader v-model="labelForm.deptPath" :options="deptTree" :props="deptProps"
                  :show-all-levels="false" placeholder="该科室及下级均符合" clearable style="width: 300px"
                  :disabled="labelDisabled" @change="onDeptChange"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <span slot="label">标注人员身份</span>
                <el-select v-model="labelForm.identity" placeholder="请选择" clearable style="width: 300px"
                  :disabled="labelDisabled" @change="onIdentityChange">
                  <el-option v-for="item in identityOptions" :key="item.value" :label="item.text"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item>
                <span slot="label">{{ labelTitleLabel }}</span>
                <el-select v-if="!isStudentIdentity" v-model="labelForm.titleGuids" multiple collapse-tags
                  placeholder="请选择（按身份联动）" clearable style="width: 300px" :disabled="labelDisabled || !labelForm.identity">
                  <el-option v-for="item in labelTitleOptions" :key="item.guid" :label="item.dicName"
                    :value="item.guid"></el-option>
                </el-select>
                <el-cascader v-else v-model="labelForm.majorPath" :options="deptTree" :props="deptProps"
                  :show-all-levels="false" placeholder="请选择专业" clearable style="width: 300px"
                  :disabled="labelDisabled" @change="onMajorChange"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item>
                <span slot="label">标注经验</span>
                <el-input v-model="labelForm.experience" maxlength="100" placeholder="请输入，如：3年以上影像标注经验"
                  style="width: 300px" :disabled="labelDisabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 传统任务类型：任务模版明细（v-show 保住 $refs.templateConfig 既有引用） -->
      <templateConfig v-show="!isLabelTask" @setRule="setRule" @seeForecast="seeForecast" @delList="delWaitList" @delItem="delItem"
        @openTemplate="openTemplate" :sendTenantGuid="sendTenantGuid" :sendTenantName="sendTenantName" :taskPriceModel="taskPriceModel"
        :disabled="disabled" :isPartDisabled="isPartDisabled" :configData="tableDataII" :startTime="startTime"
        :endTime="endTime" :organisationInfo="organisationInfo" :autoForecastOpen="autoForecastOpen" ref="templateConfig">
      </templateConfig>
      <!-- 任务明细结束 -->

      <!-- 数据标注·更多弹框（工作内容三区块，数据标注类型专属，区别于明细行"更多内容编辑"） -->
      <el-dialog title="更多内容" :visible.sync="labelMoreVisible" width="700px" :close-on-click-modal="false" append-to-body>
        <el-form label-width="110px">
          <el-form-item label="工作内容描述">
            <el-input type="textarea" :rows="4" maxlength="500" show-word-limit placeholder="请输入"
              v-model="labelForm.workDesc" :disabled="labelDisabled"></el-input>
          </el-form-item>
          <el-form-item label="工作内容明细">
            <el-input type="textarea" :rows="4" maxlength="500" show-word-limit placeholder="请输入"
              v-model="labelForm.workDetail" :disabled="labelDisabled"></el-input>
          </el-form-item>
          <el-form-item label="任务管理要求">
            <el-input type="textarea" :rows="4" maxlength="500" show-word-limit placeholder="请输入"
              v-model="labelForm.workRequire" :disabled="labelDisabled"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button size="small" @click="labelMoreVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

      <!-- 流程 开始 -->
      <div class="flow" v-if="taskType == '1'">
        <iframe scrolling="no"  :src="iframeSrc" class="iframe-sty"></iframe>
      </div>
      <!-- 流程结束 -->
      <div class="btn-groups">
        <el-button class="btn-common btn-border-gray" size="mini" type="info" @click="$router.go(-1)">取消</el-button>

        <el-button class="btn-common btn-border-green" size="mini" type="info" @click="submitReq(0)"
          v-if="!disabled">保存，暂不提交</el-button>
        <el-button class="btn-common btn-border-green" size="mini" type="info" @click="confirmTemplate"
          v-if="!disabled && !isLabelTask">保存模板</el-button>

        <el-button class="btn-common" size="mini" type="info" @click="submitReq(1)"
          v-if="!disabled">{{ taskType == '1' ? '提交审核' : '提交药企确认' }}</el-button>
        <el-button class="btn-common btn-border-green" size="mini" type="info" @click="toRevoke"
          v-if="disabled && detail.bizApproveVO && detail.bizApproveVO.approveState == 'A' && detail.bizApproveVO.staffGuid == staffGuid">撤销</el-button>
        <el-button class="btn-common btn-border-green" size="mini" type="info" @click="rejectDialogVisible = true"
          v-if="disabled && detail.bizApproveVO && detail.bizApproveVO.approveState == 'A' && detail.bizApproveVO.approveStaffGuids.indexOf(staffGuid) > -1">驳回</el-button>
        <el-button class="btn-common" size="mini" type="info" @click="passDialogVisible = true"
          v-if="disabled && detail.bizApproveVO && detail.bizApproveVO.approveState == 'A' && detail.bizApproveVO.approveStaffGuids.indexOf(staffGuid) > -1">通过</el-button>
      </div>
    </el-form>
    <!-- 选择发布人员 开始 -->
    <el-dialog title="选择人员" :visible.sync="visible3" width="70%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入部门名称"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree class="filter-tree" :data="areaData"  node-key="guid" show-checkbox
              :filter-node-method="filterNodeDep" @node-click="nodeClick" ref="treeDep" check-strictly
              @check-change="handleNodeClick1" >
              <div class="custom-tree-node" slot-scope="{ node, data }">
                <img v-if="data.nodeType == 1" src="../../assets/images/ico_ora.png" alt="" />
                <img v-else src="../../assets/images/icon_per.png" alt="">
                <span>{{ data.name }}{{ data.mobileNo || '' }}</span>
              </div>
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb fl">已选{{ departmentList.length }}个成员</p>
            <el-button size="medium" type="danger" @click="delDepartment()" class="fr" style="margin-top: 5px">批量删除
            </el-button>
            <el-table :data="departmentList" border height="280px" style="width: 100%"
              @selection-change="handleSelectionChange1">
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column header-align="center" align="center" show-overflow-tooltip prop="staffName" label="名称">
                <template slot-scope="scope">
                  {{ scope.row.staffName }}{{ scope.row.mobileNo }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="visible3 = false">取消</el-button>
        <el-button size="medium" type="info" @click="departmentSure()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 选择发布人员 结束 -->

    <!--任务模版选择  开始  -->
    <el-dialog v-if="visible4" title="选择任务模版" :visible.sync="visible4" width="1260px" center>
      <el-tabs v-model="activeTemlate" @tab-click="tableClick">
        <el-tab-pane label="合同任务" name="2"></el-tab-pane>
        <el-tab-pane label="超级模版" name="0"></el-tab-pane>
        <el-tab-pane label="项目模版" name="1"></el-tab-pane>
      </el-tabs>
      <!-- 合同任务模版 -->
      <section v-if="activeTemlate == '2'" class="back-color-fff content-main-box">
        <section style="margin-top: 10px">
          <div class="search-row">
            <div class="search-col">
              <span class="search-name contract-name">合同名称：</span>
              <el-select v-model="contractPage.guid" @change="getContractTemplateList(true)" style="width: 300px"
                filterable placeholder="请选择合同">
                <el-option v-for="item in contractList" :key="item.guid" :label="item.contractName"
                  :value="item.guid"></el-option>
              </el-select>
            </div>
            <div class="search-col">
              <span class="search-name contract-name">平台任务名称：</span>
              <el-input v-model="contractPage.oldTaskContentName" style="width: 300px"
                placeholder="请输入平台任务名称"></el-input>
            </div>
          </div>
          <div class="search-row">
            <div class="search-col">
              <span class="search-name contract-name">项目任务名称：</span>
              <el-input v-model="contractPage.taskContentName" style="width: 300px" placeholder="请输入项目任务名称"></el-input>
            </div>
            <div class="search-col" style="margin-left: 244px">
              <el-button size="medium" type="info" @click="getContractTemplateList(true)">搜索</el-button>
              <el-button size="medium" type="danger" @click="emptySearchContract">清空</el-button>
            </div>
          </div>
        </section>
        <el-table v-if="activeTemlate == '2'" border :data="contractTemplateList" row-key="guid" ref="contractTable"  style="width: 100%;height:360px;overflow-y:scroll;"
        @selection-change="handleSelectContract" @row-click="handleClickContract">
          <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="taskContentName" label="项目任务名称" show-overflow-tooltip header-align="center"
          align="left">
            <template slot-scope="scope">{{ scope.row.tenantTaskContentName }}</template>
          </el-table-column>
          <el-table-column prop="staffTaskNote" label="平台任务名称" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="tenantTaskNote" label="任务简述" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.tenantTaskNote }}</template>
          </el-table-column>

          <el-table-column prop="menuName" label="药企合同价格" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">
              <!-- {{ scope.row.tenantTaskPrice }} {{ scope.row.tenantTaskPriceUnit }} -->
              <div v-if="scope.row.tenantMaxPrice">
              {{ scope.row.tenantMinPrice }} ～ {{ scope.row.tenantMaxPrice }}{{ scope.row.tenantTaskPriceUnit }}
              </div>
              <div v-else>
              {{scope.row.tenantTaskPrice}}{{ scope.row.tenantTaskPriceUnit }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="menuName" label="结算标准" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskTotalType }}</template>
          </el-table-column>
        </el-table>
        <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2" :page-sizes="[10, 20,50,100, 200]" :current-page="contractPage.pageIndex"
          :page-size="contractPage.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="contractPage.totalRows">
        </el-pagination>
      </section>
      <!-- 超级模版 -->
      <section v-if="activeTemlate == '0'" class="back-color-fff content-main-box">
        <section style="margin-top: 10px">
          <div class="search-row">
            <div class="search-col">
              <span class="search-name">任务名称：</span>
              <el-input v-model="superPage.taskContentName" style="width: 200px" placeholder="请输入任务名称"></el-input>
            </div>
            <div class="search-col">
              <span class="search-name">系统功能：</span>
              <el-input v-model="superPage.menuName" style="width: 200px" placeholder="请输入系统功能"></el-input>
            </div>
            <div class="search-col" style="margin-left: 20px">
              <el-button size="medium" type="info" @click="getSuperTemplateList(true)">搜索</el-button>
              <el-button size="medium" type="danger" @click="emptySearchSuper">清空</el-button>
            </div>
          </div>
        </section>
        <el-table v-if="activeTemlate == '0'" border :data="superTemplateList" row-key="guid" ref="superTable"
          style="width: 100%;max-height:420px;overflow-y:scroll;" @selection-change="handleSelectSuper" @row-click="handleClickSuper">
          <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (superPage.pageIndex - 1) * superPage.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="taskContentName" label="任务名称" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskContentName }}</template>
          </el-table-column>
          <el-table-column prop="taskContentName" label="终端类型分类" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">
            {{ codeTransformLable(JSON.parse(scope.row.terminalTypeClassificationJson), getCodeListByKey('终端类型分类')) }}
            </template>
          </el-table-column>
          <el-table-column prop="staffTaskNote" label="任务简述" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.staffTaskNote }}</template>
          </el-table-column>
          <!-- 药企固定指导价 -->
        <el-table-column prop="tenantTaskPrice" label="药企固定指导价" header-align="center"  align="left">
          <template slot-scope="scope">
              {{ scope.row.tenantTaskPrice }}{{ scope.row.taskPriceUnit }}
          </template>
        </el-table-column>

        <!-- 业务员固定指导价 -->
        <el-table-column prop="taskPrice" label="业务员固定指导价" header-align="center"  align="left">
          <template slot-scope="scope">
              {{ scope.row.taskPrice }}{{ scope.row.taskPriceUnit }}
          </template>
        </el-table-column>

          <!-- 药企区间指导价 -->
          <el-table-column label="药企区间指导价" header-align="center" align="left" width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.tenantMaxPrice&&scope.row.tenantMinPrice">
              {{ scope.row.tenantMinPrice }} ～ {{ scope.row.tenantMaxPrice }}{{ scope.row.tenantTaskPriceUnit }}
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>

        <!-- 业务员基础报价 -->
        <el-table-column prop="staffBasePrice" label="业务员基础报价" header-align="center"  align="left">
          <template slot-scope="scope">
            <div v-if="scope.row.staffBasePrice">
              {{ scope.row.staffBasePrice }}{{ scope.row.taskPriceUnit }}
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>

          <el-table-column prop="tenantTaskNote" label="任务说明" show-overflow-tooltip header-align="center" align="center">
            <template slot-scope="scope">{{ scope.row.tenantTaskNote }}</template>
          </el-table-column>
          <el-table-column prop="menuName" label="系统功能" show-overflow-tooltip header-align="center" align="center">
            <template slot-scope="scope">{{ scope.row.menuName }}{{ scope.row.menuRemark ? '（' + scope.row.menuRemark +
              ')' : ''
            }}</template>
          </el-table-column>

        </el-table>
        <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1" :page-sizes="[10, 20,50,100, 200]" :current-page="superPage.pageIndex"
          :page-size="superPage.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="superPage.totalRows">
        </el-pagination>
      </section>
      <!-- 项目模版 -->
      <section class="scheme-template back-color-fff content-main-box" v-if="activeTemlate == '1'">
        <section style="margin-top: 10px">
          <div class="search-row">
            <div class="search-col">
              <span class="search-name">发布药企：</span>
              <el-select v-model="schemPage.sendTenantGuid" @change="handleChangeCompany" style="width: 300px" filterable
                placeholder="请选择委托方">
                <el-option v-for="item in sendTenantList" :key="item.guid" :label="item.sendTenantName"
                  :value="item.sendTenantGuid"></el-option>
              </el-select>
            </div>
            <div class="search-col">
              <span class="search-name">模版名称：</span>
              <el-input v-model="schemPage.templateName" style="width: 300px" placeholder="请输入模版名称"></el-input>
            </div>
          </div>
          <div class="search-row">
            <div class="search-col">
              <span class="search-name">下发部门：</span>
              <el-select v-model="schemPage.organisationInfo" filterable placeholder="请选择执行部门" class="fl"
                style="width: 300px">
                <el-option v-for="item in organisationList" :key="item.guid" :label="item.organisationName"
                  :value="item.guid"></el-option>
              </el-select>
            </div>
            <div class="search-col" style="margin-left: 220px">
              <el-button size="medium" type="info" @click="getSchemeTemplateList(true)">搜索</el-button>
              <el-button size="medium" type="danger" @click="emptySearchScheme">清空</el-button>
            </div>
          </div>
        </section>

        <el-table v-if="activeTemlate == '1'" border :data="schemeTemplateList" row-key="guid" ref="dataTable"
        style="width: 100%;max-height:470px;overflow-y:scroll;" @select="handleSelectScheme" @row-click="handleClickScheme">
          <el-table-column type="selection" :reserve-selection="true"> </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{ (schemPage.pageIndex - 1) * schemPage.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="templateName" label="模版名称" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.templateName }}</template>
          </el-table-column>
          <el-table-column prop="tenantName" label="发布药企" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.tenantName }}</template>
          </el-table-column>
          <el-table-column prop="organisationList" label="发布部门" show-overflow-tooltip header-align="center"
            align="left">
            <template slot-scope="scope">{{ getDeliverName(scope.row.organisationInfo) }}</template>
          </el-table-column>
          <el-table-column prop="taskTotal" label="系统功能" show-overflow-tooltip header-align="center" align="left">
            <template slot-scope="scope">共{{ scope.row.taskTotal }}项</template>
          </el-table-column>
        </el-table>
        <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-sizes="[10, 20,50,100, 200]" :current-page="schemPage.pageIndex"
          :page-size="schemPage.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="schemPage.totalRows">
        </el-pagination>
      </section>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="medium" @click="cancelChooseTemplate">取消</el-button>
        <el-button size="medium" type="info" @click="sureChooseTemplate">确定</el-button>
      </div>
    </el-dialog>
    <!--任务模版选择  结束  -->

    <!-- 选择部门人员 开始 -->
    <ChooseUser ref="chooseDepartment" :tenantGuid="sendTenantGuid" @onSelect="onDepartmentSelect"></ChooseUser>
    <!-- 选择部门人员 结束 -->


    <!-- 智能预测 开始 -->
    <el-dialog class="ai-class" :title="!isForeCastDetail ? '配置预测规则' : '查看预测规则'" :visible.sync="visible6" width="50%"
      center>
      <div class="ai-tips">说明：系统自动根据历史数据预估任务量，所以此方案更适用于历史数据量多且人员稳定的团队哦！</div>
      <div class="ai-content">
        <div class="ai-item">
          <span class="lable">执行部门：</span>
          <span class="value">{{ autoForecastJson.parmValue1 }}</span>
          <span class="ai-color" v-if="autoForecastJson.parmValue3">其中{{ autoForecastJson.parmValue3 }}人无历史数据无法预测</span>
        </div>
        <div class="ai-item">
          <span class="lable">预测总额：</span>
          <span class="value">{{ autoForecastJson.parmValue2 }}元</span>
          <span class="other1">(大写:{{ autoForecastJson.parmValue2 | smallToBig }})</span>
          <span class="other2" @click="downloadForeCastMoney" v-if="!isForeCastDetail"> 下载费用明细</span>
        </div>
      </div>
      <div class="download-btns">
        <span class="lable">预测规则：</span>
        <div class="btns" v-if="!isForeCastDetail">
          <div class="btn1" @click="autoForeCastCalc">点我开始计算</div>
          <div class="btn2" @click="downloadForeCastTask" v-if="downloadBtn">下载预测任务量</div>
        </div>
      </div>
      <el-table :data="autoForecastJson.detailParam" border style="width: 100%;margin:20px 0;">
        <el-table-column prop="taskContentName" label="任务名称" header-align="center" align="center">
        </el-table-column>
        <el-table-column label="任务占比" header-align="center" align="center">
          <template slot-scope="scope">
            <div style="display:flex;align-items:center;justify-content:center;">
              <el-input v-if="!isForeCastDetail" type="input" style="width: 80px;margin-right:5px;" :maxlength="30"
                placeholder="请输入" v-model="scope.row.taskTotalPercent" onkeyup="value=value.replace(/[^\d]/g,'')">
              </el-input>
              <span v-else>{{ scope.row.taskTotalPercent }}</span>
              <span>%</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="任务单价" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.taskPrice }}{{ scope.row.taskPriceUnit }}
          </template>
        </el-table-column>
        <el-table-column label="任务量" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.foreCastTaskTotal }}
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="visible6 = false">{{ !isForeCastDetail ? '取 消' : '关 闭' }}</el-button>
        <el-button size="medium" type="info" v-if="!isForeCastDetail" @click="submitReq(3)">确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- 智能预测 结束 -->

    <!--修改任务包名 开始 -->
    <el-dialog title="修改任务包名称" :visible.sync="visible7" width="800px">
     
        <div class="title-memo"> 
            <div class="title-memo-title">
              <span style="color: red">*</span>
              <span style="font-weight:600">任务包名称: </span>
            </div>
            <div class="title-memo-label">{{ taskTitle }}</div>
           <el-input style="width: 290px;margin-left:10px;" type="text"  :maxlength="8" placeholder="仅可输入8个字符" v-model="newTaskTitleTxt"/>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="visible7 = false;">取 消</el-button>
        <el-button size="medium" type="info" @click="visible7 = false">确 定</el-button>
      </span>
    </el-dialog>
    <!--修改任务包名 结束 -->

    <!--执行规则 开始  -->
    <el-dialog title="设置执行规则" :visible.sync="visible8" width="670px">
      <el-form label-width="140px" label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">应用端</span>
          <div style="display:flex;">
            <span style="display:flex;">
              <el-checkbox :disabled="disabled" style="margin-right: 10px;" v-model="ismobile"></el-checkbox>移动端
            </span>
            <span style="display:flex;margin-left:20px">
              <el-checkbox disabled style="margin-right: 10px;" v-model="ispc"></el-checkbox>PC端
            </span>
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">执行顺序</span>
          <div style="display:flex;flex-direction:column;text-align: left;">
            <el-radio :disabled="disabled" style="margin-bottom:10px" v-model="orderType" label="1">按任意顺序执行任务</el-radio>
            <el-radio :disabled="disabled" v-model="orderType" label="2">必须按顺序执行（上个任务执行完成，才可执行下个任务）</el-radio>
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label" :style="orderType == 2 ? 'color:red;' : 'color:white'">*</span>
          <span slot="label">执行间隔</span>
          <span style="display:flex;">
            <el-checkbox :disabled="disabled" style="margin-right: 10px;" v-model="isNextDay"></el-checkbox>上个任务执行完成后的
            <el-input style="width:50px;margin:0 5px;" v-model="nextDay" :disabled="disabled" :maxlength="2"
              onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>天，才可执行下一任务。
          </span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="cancelRule">取 消</el-button>
        <el-button size="medium" type="info" @click="comfirmRule">确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- 执行规则 结束 -->

    <!-- 超龄弹层 开始 -->
    <el-dialog :visible.sync="visible9" width="670px">
      <template slot="title">
        <span style="color:red;">存在年龄超标人员，请先处理再发包</span>
      </template>
      <el-table border :data="overAgeList" style="width:100%;">
        <el-table-column label="人员名称" prop="staffName" show-overflow-tooltip header-align="center" align="left">
        </el-table-column>
        <el-table-column label="手机号" prop="mobileNo" header-align="center" align="left"> </el-table-column>
        <el-table-column label="所在直属部门" prop="organisationName" header-align="center" align="left"> </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="info" @click="downloadOverAgeList">下载人员名单
        </el-button>
        <el-button size="medium" plain @click="visible9 = false;">返 回</el-button>
      </span>
    </el-dialog>
    <!-- 超龄弹层 结束-->

    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" maxlength="100" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" maxlength="100" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    

  </div>
</template>

<script>
import { bpmnroute } from '@/api/apiRoute';
import moment from 'moment';
import templateConfig from '@/components/templateConfig.vue';
import ChooseUser from './components/chooseUser';
import LabelTemplateSelect from '@/views/certManagement/components/LabelTemplateSelect.vue';
import { LABEL_TASK_TYPE } from './enum.js';
import { getPlatformDeptTenantGuid } from '@/uilt/platformDeptGuid';
import { countTaskLabels, MAX_TASK_LABELS, sameTaskSnapshots, hasInvalidTaskSnapshots } from '@/uilt/labelTaskCapacity';

export default {
  components: {
    ChooseUser,
    templateConfig,
    LabelTemplateSelect
  },
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      maxTaskLabels: MAX_TASK_LABELS,
      rejectDialogVisible: false,
      passDialogVisible: false,
      approveSuggest: '',
      iframeSh: false,
      iframeSrc: '',
      staffGuid: userinfo.staffGuid,


      overAgeOrg: [],//超龄组织guid集合
      visible9: false,
      overAgeList: [],//超龄list

      autoForecastOpen: '0',//是否开启智能预测
      timeType: '按月',
      timeRange: '',
      year: '',
      month: '',
      taskPriceModel:'1',
      startTime: '',
      endTime: '',
      taskTitle: '',
      taskType: '1',//模版类型
      templateTypeList: [{
        label: '正式',
        value: '正式模版'
      }, {
        label: '测试',
        value: '测试模版'
      }],
      tenantName: '',
      templateGuid: '',
      superTemplateGuid: '',
      templateName: '',
      tenantList: [],
      taskContentList: [],
      templateList: [],
      tableDataII: [],
      visible2: false,
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        taskContentName: '',
        tenantName: '',
        tenantGuid: '',
      },
      schemPage: { //项目模版请求参数
        serviceTenantGuid: localStorage.guid,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        isSuper: 'N',
        sendTenantGuid: '',
        tenantGuid: localStorage.guid,
        tenantName: '', //药企名称
        templateName: '', //模版名称
        organisationInfo: '',
        isUse: 'Y',
      },
      superPage: {//超级模版请求参数
        isSuper: 'Y',
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        bizState:'Y',
        taskContentName: null, //任务名称
        menuName: '', //菜单名称
      },
      contractPage: { //合同模版请求参数
        guid: '',
        taskContentName: '',
        oldTaskContentName:''
      },

      superTemplateList: [], //超级模版列表
      schemeTemplateList: [], //普通模版列表
      templateSelectd: '', //被临时选中的项目模板
      chooseTemplate: '', //最终被选中的模版

      organisationList: [],
      sendTenantList: [],
      tableData: [],
      multipleSelection: [],

      visible3: false,
      area: [],
      departmentList: [],
      departmentData: '',
      areaData: [],
      delList: [],
      filterText: '',
      fullscreenLoading: false,

      isPartDisabled: false,
      disabled: false,
      detail: {},
      serviceTenantName: JSON.parse(localStorage.userInfo).tenantName,
      sendTenantName: null,
      sendTenantGuid: null,
      serviceTenantGuid: localStorage.guid,
      loadingCount: 0,

      visible4: false,
      activeTemlate: "2",

      departmentListII: [],
      visible5: false,
      areaII: [],
      areaDataII: [],
      delListII: [],
      filterTextII: '',
      tempSuperTemplate: [], //临时选中的超级模版

      newTemplateName: '',//模版名称
      visible6: false,

      organisationInfo: '', //执行部门
      orignTableII: [],

      visible7: false,
      newTaskTitleTxt: '',
      autoForecastJson: {},
      isForeCastDetail: false,
      downloadBtn: false,

      visible8: false,
      orderType: '1',
      isNextDay: false,
      ismobile: true,//是否是手机端
      ispc: false, //是否是pc端
      nextDay: '',
      openOrgAlert: false,
      openOrgAlertMsg: '',
      contractList: [],
      contractTemplateList: [],
      //限制品种弹窗
      showGoodsLimitSelect:false,

      // ===== v26.3.3 数据标注类型（任务包协配）=====
      labelMoreVisible: false, //更多内容弹框（工作内容三区块）
      labelConfigRaw: '', //回显的 labelConfig 原文（确认人修改比对用）
      originalLabelSources: [], // 详情加载时保留原标注明细与数据集关联，仅作为后端核对线索
      originalLabelSnapshotInvalid: false, // 历史快照格式异常时不覆盖原数据
      datasetOptions: [], //数据集候选（仅待标注 N）
      modelOptions: [], //预标注模型候选（启用）
      deptTree: [], //科室树（平台租户 mf_med_dept，环境分支同小程序，统一口径）
      deptProps: { value: 'guid', label: 'deptName', children: 'childList', checkStrictly: true, emitPath: false },
      identityOptions: [], //认证身份字典
      titleTree: [], //职称树（按身份分组）
      labelForm: {
        datasetGuids: [], //已选数据集（N7 行级化：多选，同模态约束，生成对应数量 SJBZ 明细行）
        datasetName: '',
        dataAmount: '',
        dataUnit: '',
        dataModalGuid: '',
        dataModalName: '',
        qcRatio: '100', //质检比例（必填整型 0<x≤100，默认100）
        labelSnapshots: [null], //标签快照列表（FOUR-3001 多下拉；null=待选行，提交时过滤）
        modelGuid: '',
        modelName: '',
        deptPath: '', //科室（任意层级单选=该科室及下级符合）
        deptGuid: '',
        deptName: '',
        identity: '', //标注人员身份
        titleGuids: [], //职称（多选，按身份联动）
        majorPath: '', //医学生-专业（科室树单选）
        majorGuid: '',
        majorName: '',
        experience: '', //标注经验
        workDesc: '', //更多：工作内容描述
        workDetail: '', //更多：工作内容明细
        workRequire: '', //更多：任务管理要求
      },
    };
  },
  computed: {
    labelSelectionCount() {
      return countTaskLabels(this.labelForm.labelSnapshots);
    },
    labelSelectionTemplateCount() {
      return (this.labelForm.labelSnapshots || []).filter(Boolean).length;
    },
    // 数据标注任务类型分支（字典值见 LABEL_TASK_TYPE；宽松等于防后端返回数字类型）
    isLabelTask() {
      return this.taskType == LABEL_TASK_TYPE;
    },
    // 模型下拉：启用态全量基础上按所选数据集模态过滤（三方模态一致性；未选数据集时不过滤）
    filteredModelOptions() {
      if (!this.labelForm.dataModalGuid) return this.modelOptions;
      const list = this.modelOptions.filter((item) => item.dataModalGuid === this.labelForm.dataModalGuid);
      // 回显豁免：已保存的模型选择不在过滤结果（存量模型未归模态）时保留该行，防编辑回显丢值
      if (this.labelForm.modelGuid && !list.some((item) => item.guid === this.labelForm.modelGuid)) {
        const cur = this.modelOptions.find((item) => item.guid === this.labelForm.modelGuid);
        if (cur) list.push(cur);
      }
      return list;
    },
    // 医学生身份：职称字段切换为专业（科室树单选）
    isStudentIdentity() {
      return this.labelForm.identity === '5';
    },
    labelTitleLabel() {
      return this.isStudentIdentity ? '标注人员专业' : '标注人员职称';
    },
    // 职称选项：按身份取职称树对应分组（认证线 certInfoManage 同源）
    labelTitleOptions() {
      const groupName = { '1': '医生职称', '2': '护士职称', '3': '药师职称', '4': '技师职称' }[this.labelForm.identity];
      if (!groupName) return [];
      const group = (this.titleTree || []).find((item) => item.dicName === groupName);
      return group && group.childList ? group.childList : [];
    },
    // 审批人（药企确认人）在审批中状态可修改数据标注内容（2026-09-07 定稿：确认时支持修改）
    canLabelApproveEdit() {
      return this.isLabelTask
        && this.disabled
        && this.detail.bizApproveVO
        && this.detail.bizApproveVO.approveState == 'A'
        && (this.detail.bizApproveVO.approveStaffGuids || '').indexOf(this.staffGuid) > -1;
    },
    // 数据标注字段禁用态：编辑态可改；详情态仅审批人确认时可改
    labelDisabled() {
      if (!this.disabled) return false;
      return !this.canLabelApproveEdit;
    },
  },
  created() {
    this.getSendTenantList();
    this.getTaskContentList();
    this.loadLabelOptions();
    //获取详情
    this.getDetail();
  },
  watch: {
    // 委托方切换/详情回显后重载科室树（统一平台租户口径后树不变，守卫防重复请求；
    // 保留 watch 兼容既有触发链）
    sendTenantGuid() {
      this.loadLabelDeptTree();
    },
    orderType(newVal) {
      if (newVal == '2') {
        this.isNextDay = true;
        if (!this.$route.query.guid) {
          this.nextDay = 15;
        }
      } else {
        this.isNextDay = false;
        this.nextDay = '';
      }
    },
    nextDay(newVal) {
      if (newVal) {
        this.orderType = '2'
        this.isNextDay = true;
      }
    },
    timeRange(newVal) {
      if (!newVal) return;
      this.startTime = newVal[0];
      this.endTime = newVal[1];
      setTimeout(() => {
        this.$refs.templateConfig.getPlanCount();
      }, 200)

    },
    filterText(val) {
      this.$refs.treeDep.filter(val);
    },
    filterTextII(val) {
      this.$refs.treeII.filter(val);
    },
    year(year) {
      if (this.disabled) return;
      if (!year) return;
      this.startTime = year + '-01-01';
      this.endTime = year + '-12-31';
      setTimeout(() => {
        this.$refs.templateConfig.getPlanCount();
      }, 200)
    },
    month(month) {
      if (this.disabled) return;
      if (!month) return;
      // FOUR-3008：编辑回显时 sendTenantGuid 已同步赋值，优先直用；
      // 不能只按名称匹配 rel-list（列表未返回时会误判"未选委托企业"并把回显月份连带清空——3009 null.replace 崩溃的源头）
      let tenantGuid = this.sendTenantGuid || '';
      if (!tenantGuid) {
        let tenantList = this.sendTenantList;
        tenantList.forEach((item) => {
          if (item.sendTenantName == this.sendTenantName) {
            tenantGuid = item.sendTenantGuid;
          }
        });
      }
      if (!tenantGuid) {
        this.$message.error('请先选择委托企业');
        return;
      }
      let reqDate = month + '-01';
      this.api
        .get(
          `/${serverConfig.msConfigureService}/sysparameter/data/get-account-month-full-area?date=` +
          reqDate +
          '&tenantGuid=' +
          tenantGuid,
        )
        .then((resp) => {
          if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.startTime = resp.data.data.split(',')[0];
            this.endTime = resp.data.data.split(',')[1];
            setTimeout(() => {
              this.$refs.templateConfig.getPlanCount();
            }, 200)
          }else{
            this.$message.error(resp.data.msg);
            this.month = null;
          }
        });
    },
    timeType(val) {
      if (this.disabled) return;
      this.startTime = '';
      this.endTime = '';
      this.year = '';
      this.month = '';
      if (val && this.startTime && this.endTime && this.taskType && this.departmentListII && this.departmentListII.length > 0) {
        this.getTaskName();
      }

    },
    startTime(val) {
      if (val && this.timeType && this.endTime && this.taskType && this.departmentListII && this.departmentListII.length > 0) {
        this.getTaskName();
      }
    },
    endTime(val){
      if (this.disabled) return;
      if(!val) return;
      if (new Date(this.$moment(new Date()).format('YYYY-MM-DD')).getTime()>new Date(this.$moment(val).format('YYYY-MM-DD')).getTime()) {
        this.$confirm(`系统检测你正在倒发任务包，请仔细核实你所选的时间`, '提示', {
          showCancelButton: false,
          confirmButtonText: '好的，我知道了',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => { })
        return;
      }
      // if (new Date() > new Date(val)) {
      //   this.$confirm(`系统检测你正在倒发任务包，请仔细核实你所选的时间`, '提示', {
      //     showCancelButton: false,
      //     confirmButtonText: '好的，我知道了',
      //     cancelButtonText: '取消',
      //     type: 'warning',
      //   }).then(() => { })
      //   return;
      // }
    },
    taskType(val) {
      if (val && this.timeType && this.startTime && this.endTime && this.departmentListII && this.departmentListII.length > 0) {
        this.getTaskName();
      }
    },
    departmentListII: {
      handler(newValue) {
        if (newValue && newValue.length > 0 && this.startTime && this.endTime && this.taskType && this.timeType) {
          this.getTaskName();
        }
      },
      deep: true
    },
    visible9(val) {
      if (!val) {
        let departmentListII = this.departmentListII;
        let personList = [];
        departmentListII.forEach(i => {
          personList.push(i.guid);
        });
        this.$refs.chooseDepartment.open(personList);
      }
    },
    
  },
  methods: {
    codeTransformLable(val, list) {
      if (!val || !val.length) return '-';
      let result = [];
      if (typeof val == 'string') {
        list.forEach(item => {
          if (item.value == val) {
            result.push(item.text);
          }
        })
      } else {
        list.forEach(item => {
          val.forEach(el => {
            if (el == item.value) {
              result.push(item.text);
            }
          })
        })
      }
      return result.join('、');
    },
    //获取超限人员名单
    getOverAgeList() {
      let req = {
        objectList: this.overAgeOrg,
        tenantGuid: this.sendTenantGuid
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-over-age-staff-list`, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.overAgeList = res.data.data;
          this.visible9 = true;
          this.visible5 = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //下载超龄人员
    downloadOverAgeList() {
      let req = {
        objectList: this.overAgeOrg,
        tenantGuid: this.sendTenantGuid
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/export-over-age-staff-list`, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //确认执行规则
    comfirmRule() {
      if (!this.ismobile) {
        this.$message.error('请选择应用端');
        return;
      }
      if (!this.isNextDay && this.orderType == 2) {
        this.$message.error('请勾选执行间隔');
        return;
      }
      if (!this.nextDay && this.orderType == 2) {
        this.$message.error('请填写间隔天数');
        return;
      }
      this.visible8 = false;

    },
    //取消执行规则
    cancelRule() {
      let nextDay = this.detail.nextDay;
      let orderType = this.detail.orderType;
      if (orderType == 1 || !orderType) {
        this.orderType = '1';
        this.isNextDay = false;
        this.nextDay = '';
      }
      if (orderType == 2) {
        this.orderType = '2';
        this.isNextDay = true;
        this.nextDay = nextDay;
      }
      this.visible8 = false;
    },
    //计算任务量
    autoForeCastCalc() {
      let detailParam = this.autoForecastJson.detailParam;
      let allTotal = 0;
      try {
        detailParam.forEach(item => {
          if (!item.taskTotalPercent) {
            throw new Error('任务占比不能为空');
          }
          allTotal += +item.taskTotalPercent;
        })
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      if (allTotal != 100) {
        this.$message.error('各占比之和必须为100%才能计算');
        return;
      }
      let map = new Map();
      let taskDetailNum = Object.create(null)
      detailParam.forEach(item => {
        map.set(item.templateDetailGuid, +item.taskTotalPercent)
      })
      for (let [k, v] of map) {
        taskDetailNum[k] = v;
      }
      let query = {
        staffMoneyList: this.autoForecastJson.staffMoneyList,
        taskDetailNum: taskDetailNum,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-staff-task-count`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data;
          this.autoForecastJson.staffMoneyList = data.staffMoneyList;
          this.autoForecastJson.taskCount = data.taskCount;
          this.autoForecastJson.staffTaskCountList = data.staffTaskCountList;
          this.autoForecastJson.detailParam.forEach((item, index) => {
            item.foreCastTaskTotal = data.taskCount[item.templateDetailGuid]
          })
          this.autoForecastJson = JSON.parse(JSON.stringify(this.autoForecastJson))
          this.downloadBtn = true;

        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    //下载预测任务量
    downloadForeCastTask() {
      let detailParam = this.autoForecastJson.detailParam;
      try {
        detailParam.forEach(item => {
          if (!item.foreCastTaskTotal) {
            throw new Error('请先点击计算后下载预测量');
          }
        })
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      let map = new Map();
      let taskDetailNum = Object.create(null)
      detailParam.forEach(item => {
        map.set(item.templateDetailGuid, +item.taskTotalPercent)
      })
      for (let [k, v] of map) {
        taskDetailNum[k] = v;
      }
      let query = {
        staffMoneyList: this.autoForecastJson.staffMoneyList,
        taskDetailNum: taskDetailNum
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/export-staff-task-count`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    //预测总额
    auoForeCastMoney() {
      let autoForecastJson = this.autoForecastJson;
      this.autoForecastJson.detailParam.forEach(el => {
        el.foreCastTaskTotal = null;
      })
      let organisationInfo = [];
      this.departmentListII.forEach((item) => {
        organisationInfo.push({
          guid: item.guid,
          name: item.organisationName,
          objectType: item.nodeType == '1' ? '组织' : '人员'
        });
      });
      let query = {
        tenantGuid: this.sendTenantGuid,
        organisationInfo: JSON.stringify(organisationInfo),
        isTeamLeader: autoForecastJson.detailParam[0].isTeamLeader,
        serviceTenantGuid: localStorage.guid
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-task-money-forecast`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let list = res.data.data;
          let totalMoney = 0;
          let emptyNum = 0;
          list.forEach(el => {
            if (!el.taskMoney) {
              emptyNum++;
            }
            totalMoney += el.taskMoney;
          })
          this.autoForecastJson.staffMoneyList = list;
          this.autoForecastJson.parmValue2 = parseInt(totalMoney);
          this.autoForecastJson.parmValue3 = emptyNum;
          this.$confirm('将进行智能预测任务量,请配置预测规则', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.visible6 = true;
            this.downloadBtn = false;
          }).catch(() => {

          })

        } else {
          this.$alert(res.data.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.autoForecastOpen = '0';
            }
          })

        }
      })
    },
    //下载费用明细
    downloadForeCastMoney() {
      let organisationInfo = [];
      this.departmentListII.forEach((item) => {
        organisationInfo.push({
          guid: item.guid,
          name: item.organisationName,
        });
      });
      let query = {
        tenantGuid: this.sendTenantGuid,
        organisationInfo: JSON.stringify(organisationInfo),
        isTeamLeader: this.autoForecastJson.detailParam[0].isTeamLeader,
        serviceTenantGuid: localStorage.guid
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/export-task-money-forecast`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
        } else {
          this.$message.error(res.data.msg);
        }
      })

    },
    //导出明细
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        });
    },

    seeForecast() {
      this.visible6 = true;
      this.isForeCastDetail = true;
    },
    //设置执行规则
    setRule() {
      this.visible8 = true;
    },
    // ===== v26.3.3 数据标注类型（任务包协配）=====
    // 数据源加载：数据集（仅待标注）/模型（启用）/科室树/职称树/身份字典
    loadLabelOptions() {
      this.loadDatasetOptions();
      this.api.postJson(`/${serverConfig.msSalesPerformService}/prelabel-model/page-list`, {
        tenantGuid: localStorage.guid, enableState: 'Y', pageIndex: 1, pageSize: 100,
      }).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.modelOptions = res.data.data.records || [];
        }
      });
      // 科室树由 loadLabelDeptTree 统一加载（平台租户口径，带守卫与脏 guid 清理）
      this.api.get(`/${serverConfig.msConfigureService}/dict/get-tree-by-dictType?dictType=职称`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.titleTree = res.data.data || [];
        }
      });
      this.loadLabelDeptTree();
      this.identityOptions = this.getCodeListByKey('认证身份');
      if (!this.identityOptions.length) {
        // 兜底：字典未配置时按约定值展示（certInfoManage 同款）
        this.identityOptions = [
          { value: '1', text: '医生' }, { value: '2', text: '护士' }, { value: '3', text: '药师' },
          { value: '4', text: '技师' }, { value: '5', text: '医学生' }, { value: '6', text: '其他' },
        ];
      }
    },
    /**
     * 科室树统一取平台租户（mf_med_dept 配置表业务，环境分支同小程序 getPlatformGuid；
     * 认证/协配/模板配置/候选过滤同树，guid 体系天然一致——登录租户或委托方租户的树
     * 选出的 guid 跨体系对候选过滤永无命中，09-18 测试库实证）。
     * 触发：首次进入 + 委托方切换/详情回显（watch sendTenantGuid，守卫防重复请求）。
     */
    loadLabelDeptTree() {
      // 科室树=平台租户树（全局唯一体系）。保留一次性守卫防重复请求；
      // 旧选中科室/专业不在平台树内则清空（脏 guid 留值必致候选过滤为空）
      if (this.deptTreeTenantGuid === 'PLATFORM') return;
      this.deptTreeTenantGuid = 'PLATFORM';
      this.api.get(`/${serverConfig.msPersonnelService}/staff-cert/dept-tree?tenantGuid=${getPlatformDeptTenantGuid()}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.deptTree = res.data.data || [];
          // 切换后旧选中科室/专业不在树内则清空（跨体系死配置，留值必致候选过滤为空）
          ['deptGuid', 'majorGuid'].forEach((key) => {
            if (this.labelForm[key] && !this.findDeptName(this.deptTree, this.labelForm[key])) {
              if (key === 'deptGuid') {
                this.labelForm.deptPath = [];
                this.labelForm.deptName = '';
              } else {
                this.labelForm.majorPath = [];
                this.labelForm.majorName = '';
              }
              this.labelForm[key] = '';
            }
          });
        }
      });
    },
    datasetLabel(item) {
      return item.dataAmount !== '' && item.dataAmount != null
        ? `${item.datasetName}（${item.dataAmount}${item.dataUnit}）`
        : item.datasetName;
    },
    /** 已选数据集可能已流转非待标注状态（不在候选列表），补项保留下拉回显（多选逐个补） */
    ensureDatasetOption() {
      (this.labelForm.datasetGuids || []).forEach((guid) => {
        if (!this.datasetOptions.some((item) => item.guid === guid)) {
          this.datasetOptions.unshift({ guid, datasetName: guid, dataAmount: '', dataUnit: '', dataModalGuid: '', dataModalName: '' });
        }
      });
    },
    /** 数据集多选变更：同模态约束（标签快照/模型按单一模态过滤）；公共模态取首个已选 */
    onDatasetChange(guids) {
      let kept = (guids || []).slice();
      const first = this.datasetOptions.find((item) => item.guid === kept[0]);
      const modalGuid = first ? (first.dataModalGuid || '') : '';
      if (kept.some((g) => {
        const hit = this.datasetOptions.find((item) => item.guid === g);
        return hit && (hit.dataModalGuid || '') !== modalGuid;
      })) {
        this.$message.warning('所选数据集的数据模态须一致，已自动保留同模态部分');
        kept = kept.filter((g) => {
          const hit = this.datasetOptions.find((item) => item.guid === g);
          return hit && (hit.dataModalGuid || '') === modalGuid;
        });
        this.labelForm.datasetGuids = kept;
      }
      const hit = this.datasetOptions.find((item) => item.guid === kept[0]);
      const oldModalGuid = this.labelForm.dataModalGuid;
      this.labelForm.datasetName = hit ? hit.datasetName : '';
      this.labelForm.dataAmount = hit ? hit.dataAmount : '';
      this.labelForm.dataUnit = hit ? hit.dataUnit : '';
      this.labelForm.dataModalGuid = hit ? (hit.dataModalGuid || '') : '';
      this.labelForm.dataModalName = hit ? (hit.dataModalName || '') : '';
      // FOUR-3006：数据模态变更后已选标签全部清空（口径：全部清空，按新模态重选），下拉选项由 LabelTemplateSelect 按模态重拉
      if (oldModalGuid !== this.labelForm.dataModalGuid
        && (this.labelForm.labelSnapshots || []).filter(Boolean).length) {
        this.labelForm.labelSnapshots = [null];
      }
      // 模态变更后原选模型可能不匹配新模态，清空待重选
      if (oldModalGuid !== this.labelForm.dataModalGuid && this.labelForm.modelGuid
        && !this.filteredModelOptions.some((item) => item.guid === this.labelForm.modelGuid)) {
        this.labelForm.modelGuid = '';
        this.labelForm.modelName = '';
      }
    },
    onModelChange(guid) {
      const hit = this.modelOptions.find((item) => item.guid === guid);
      this.labelForm.modelName = hit ? hit.modelName : '';
    },
    onIdentityChange() {
      this.labelForm.titleGuids = [];
      this.labelForm.majorPath = '';
      this.labelForm.majorGuid = '';
      this.labelForm.majorName = '';
    },
    // 任意层级单选=该科室及下级均符合（checkStrictly）
    onDeptChange(guid) {
      this.labelForm.deptGuid = guid || '';
      this.labelForm.deptName = this.findDeptName(this.deptTree, guid);
    },
    onMajorChange(guid) {
      this.labelForm.majorGuid = guid || '';
      this.labelForm.majorName = this.findDeptName(this.deptTree, guid);
    },
    findDeptName(nodes, guid) {
      for (const node of nodes || []) {
        if (node.guid === guid) return node.deptName;
        const hit = this.findDeptName(node.childList, guid);
        if (hit) return hit;
      }
      return '';
    },
    // 先按数据集精确关联；只有剩余一条旧行和一条新行时才能唯一确认更换。
    resolveLabelSources() {
      const selected = this.labelForm.datasetGuids || [];
      const matched = selected.map(() => null);
      if (!this.$route.query.guid || !this.originalLabelSources.length) return { matched, ambiguous: false };
      const sources = this.originalLabelSources;
      if (sources.some((row) => typeof row.detailGuid !== 'string' || !row.detailGuid.trim()
          || typeof row.datasetGuid !== 'string')
        || selected.some((guid) => typeof guid !== 'string' || !guid.trim())
        || new Set(sources.map((row) => row.detailGuid)).size !== sources.length
        || new Set(selected).size !== selected.length) return { matched, ambiguous: true };
      const used = new Set();
      for (let index = 0; index < selected.length; index++) {
        const candidates = sources.filter((row) => row.datasetGuid === selected[index]);
        if (candidates.length > 1) return { matched, ambiguous: true };
        if (candidates.length === 1) {
          if (used.has(candidates[0].detailGuid)) return { matched, ambiguous: true };
          matched[index] = candidates[0];
          used.add(candidates[0].detailGuid);
        }
      }
      const remaining = sources.filter((row) => !used.has(row.detailGuid));
      const unassigned = matched.map((row, index) => row ? -1 : index).filter((index) => index >= 0);
      if (remaining.length === 1 && unassigned.length === 1) {
        matched[unassigned[0]] = remaining[0];
      } else if (remaining.length && unassigned.length) {
        return { matched, ambiguous: true };
      }
      return { matched, ambiguous: false };
    },
    // 数据标注提交前校验
    checkLabelForm() {
      // FOUR-3010：协配端数据集可空（药企 ES 端自建必填），不再强制"请选择标注数据"
      if (this.originalLabelSnapshotInvalid) return '原任务标签快照格式异常，请核查原任务后重试';
      if (this.resolveLabelSources().ambiguous) return '无法确认原标注明细，请核查原任务数据集配置';
      if (this.$route.query.guid && !(this.labelForm.datasetGuids || []).length && this.originalLabelSources.length
        && !(this.originalLabelSources.length === 1 && this.originalLabelSources[0].detailGuid)) {
        return '无法确认原标注明细，请核查原任务数据集配置';
      }
      // FOUR-3001：多标签，过滤空行后至少一个
      const labelSnapshots = (this.labelForm.labelSnapshots || []).filter(Boolean);
      if (!labelSnapshots.length) return '请选择标签';
      const labelCount = countTaskLabels(labelSnapshots);
      let savedConfig = null;
      try { savedConfig = this.labelConfigRaw && JSON.parse(this.labelConfigRaw); } catch (e) { /* 不完整旧数据不视为未变更 */ }
      if (labelCount > MAX_TASK_LABELS && !sameTaskSnapshots(labelSnapshots, savedConfig)) return `单条标注任务最多选择${MAX_TASK_LABELS}个标签，当前${labelCount}个，请调整标签`;
      const ratio = +this.labelForm.qcRatio;
      // 需求口径：必填整型 0<x≤100（onkeyup 清理不拦粘贴，此处 Number.isInteger 兜底）
      if (!Number.isInteger(ratio) || ratio <= 0 || ratio > 100) return '质检比例须为 0~100 的整数';
      // 模态一致性硬约束：数据集 ↔ 每个标签快照（模型表无模态字段不参与，模型与模态的关联留待 F0 契约）
      for (const snapshot of labelSnapshots) {
        if (snapshot.dataModalGuid && this.labelForm.dataModalGuid
          && snapshot.dataModalGuid !== this.labelForm.dataModalGuid) {
          return '标签模板与所选数据集的数据模态不一致，请重新选择';
        }
      }
      return '';
    },
    // 构造 labelConfig 表单快照（N7 行级化：不含数据集行级字段，作为各 SJBZ 明细行 labelConfig 的公共部分）
    buildLabelConfig() {
      const titleNames = this.labelForm.titleGuids.map((guid) => {
        const hit = this.labelTitleOptions.find((item) => item.guid === guid);
        return hit ? hit.dicName : '';
      }).filter(Boolean);
      return {
        dataModalGuid: this.labelForm.dataModalGuid,
        dataModalName: this.labelForm.dataModalName,
        qcRatio: +this.labelForm.qcRatio,
        labelSnapshots: (this.labelForm.labelSnapshots || []).filter(Boolean),
        modelGuid: this.labelForm.modelGuid,
        modelName: this.labelForm.modelName,
        deptGuid: this.labelForm.deptGuid,
        deptName: this.labelForm.deptName,
        identity: this.labelForm.identity,
        titleGuids: this.labelForm.titleGuids,
        titleNames,
        majorGuid: this.labelForm.majorGuid,
        majorName: this.labelForm.majorName,
        experience: this.labelForm.experience,
        workDesc: this.labelForm.workDesc,
        workDetail: this.labelForm.workDetail,
        workRequire: this.labelForm.workRequire,
      };
    },
    // 构造 SJBZ 明细行（N7 行级化：每个已选数据集一行，行级 labelConfig=表单快照+该数据集字段；同包两行不得同数据集由多选天然保证）
    buildLabelDetailParam() {
      const snapshot = this.buildLabelConfig();
      const sourceRows = this.resolveLabelSources();
      let originalSelection = null;
      try { originalSelection = this.labelConfigRaw && JSON.parse(this.labelConfigRaw); } catch (e) { /* 不完整旧数据不视为未变更 */ }
      const labelsUnchanged = !!this.$route.query.guid && sameTaskSnapshots(snapshot.labelSnapshots, originalSelection);
      const configFor = (source, fields) => {
        const config = { ...snapshot, ...fields };
        const old = source && source.labelConfig;
        if (labelsUnchanged && old && (Object.prototype.hasOwnProperty.call(old, 'labelSnapshot')
          || Object.prototype.hasOwnProperty.call(old, 'labelSnapshots'))) {
          // 独立任务表单回显首行标签：未修改时逐行保留各自原快照，交由后端核对。
          delete config.labelSnapshot;
          delete config.labelSnapshots;
          if (Object.prototype.hasOwnProperty.call(old, 'labelSnapshot')) config.labelSnapshot = old.labelSnapshot;
          if (Object.prototype.hasOwnProperty.call(old, 'labelSnapshots')) config.labelSnapshots = old.labelSnapshots;
        }
        return JSON.stringify(config);
      };
      if (this.$route.query.guid && !(this.labelForm.datasetGuids || []).length
        && this.originalLabelSources.length === 1 && this.originalLabelSources[0].detailGuid) {
        const source = this.originalLabelSources[0];
        return [{
          taskContentName: source.taskContentName || '标注行',
          taskContentType: 'SJBZ',
          taskTotal: null,
          taskTotalUnit: source.taskTotalUnit || '',
          sourceTaskDetailGuid: source.detailGuid,
          labelConfig: configFor(source, { datasetGuid: '', datasetName: '', dataAmount: null, dataUnit: '' }),
        }];
      }
      return (this.labelForm.datasetGuids || []).map((guid, index) => {
        const hit = this.datasetOptions.find((item) => item.guid === guid) || {};
        const datasetName = hit.datasetName || guid;
        const source = sourceRows.matched[index];
        const detail = {
          taskContentName: datasetName,
          taskContentType: 'SJBZ',
          taskTotal: hit.dataAmount != null && hit.dataAmount !== '' ? +hit.dataAmount : null,
          taskTotalUnit: hit.dataUnit || '',
          labelConfig: configFor(source, {
            datasetGuid: guid,
            datasetName,
            dataAmount: hit.dataAmount != null && hit.dataAmount !== '' ? +hit.dataAmount : null,
            dataUnit: hit.dataUnit || '',
          }),
        };
        if (source && source.detailGuid) {
          detail.sourceTaskDetailGuid = source.detailGuid;
        }
        return detail;
      });
    },
    // 确认人变更比对快照（表单快照 + 数据集 guid 集合：数据集增删即视为配置变更）
    buildLabelCompareSnapshot() {
      return JSON.stringify({
        ...this.buildLabelConfig(),
        datasetGuids: (this.labelForm.datasetGuids || []).slice().sort(),
      });
    },
    // 数据标注提交：共用任务包级字段，明细与扩展字段为占位契约（F0 与任务域后端对齐后调整）
    // silent=true 时不跳转，成功后执行 callback（供审批通过前静默保存确认人修改）
    submitLabelTask(type, silent, callback) {
      const errMsg = this.checkLabelForm();
      if (errMsg) {
        this.$message.error(errMsg);
        return;
      }
      const userinfo = JSON.parse(localStorage.userInfo);
      var organisationInfo = [];
      this.departmentListII.forEach((item) => {
        organisationInfo.push({
          guid: item.guid,
          name: item.organisationName,
          objectType: item.nodeType == '1' ? '组织' : '人员'
        });
      });
      // 包名为空时前端兜底生成（后端 init-template-name 已支持数据标注类型[4]，此处仅兜底）
      const taskTitle = this.taskTitle && this.newTaskTitleTxt
        ? this.taskTitle + '(' + this.newTaskTitleTxt + ')'
        : this.taskTitle || (this.sendTenantName + '-数据标注任务包');
      let req = {
        serviceTenantGuid: this.serviceTenantGuid,
        serviceTenantName: this.serviceTenantName,
        organisationInfo: JSON.stringify(organisationInfo),
        taskTitle,
        tenantName: this.sendTenantName,
        tenantGuid: this.sendTenantGuid,
        senderStaffGuid: this.departmentList[0].guid,
        senderStaffName: this.departmentList[0].staffName,
        timeType: this.timeType,
        startTime: this.startTime + ' 00:00:00',
        endTime: this.endTime + ' 23:59:59',
        isService: 'Y',
        // 审批中静默保存确认人修改时保持任务包原状态（勿以 type=1 的"待发布"覆盖审批状态机，F0 对齐后如后端提供独立更新接口则替换）
        state: silent ? this.detail.state : (type == 0 ? '草稿中' : '待发布'),
        autoForecastOpen: '0',
        ismobile: this.ismobile,
        orderType: this.orderType,
        nextDay: this.orderType == 2 ? +this.nextDay : 0,
        month: this.timeType == '按月' ? (this.month || '').replace('-', '') || null : null,
        submitStaffGuid: userinfo.staffGuid,
        submitStaffName: userinfo.staffName,
        taskType: this.taskType,
        // N7 行级化：SJBZ 明细行携带行级 labelConfig（数据集 GUID 交接在后端按 taskContentType=SJBZ 配对）；
        // 顶层 labelConfig 兼容保留（后端仅读行级）
        labelConfig: JSON.stringify({ ...this.buildLabelConfig(), datasetGuids: this.labelForm.datasetGuids }),
        detailParam: this.buildLabelDetailParam(),
      };
      const url = `/${serverConfig.msSalesPerformService}/task/data/add`;
      if (this.$route.query.guid) {
        req.guid = this.$route.query.guid;
        if (type != 0 && ((this.detail.bizApproveVO && this.detail.bizApproveVO.approveState == 'C') || (this.detail.bizApproveVO && this.detail.bizApproveVO.approveState == 'R'))) {
          req.guidResubmit = this.$route.query.guid;
        }
      }
      this.fullscreenLoading = true;
      this.api.postJson(url, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (silent) {
            this.labelConfigRaw = this.buildLabelCompareSnapshot();
            callback && callback();
            return;
          }
          this.$message.success(type == 0 ? '保存成功' : (this.$route.query.guid ? '重新提交成功' : '新增成功'));
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //获取任务包名称
    getTaskName() {
      // 详情/确认态（disabled）不重新生成包名：回显 watcher 连锁触发时防止异步返回覆盖真实包名
      if (this.disabled) return;
      let self = this;
      let organisationInfo = [];
      this.departmentListII.forEach((item) => {
        organisationInfo.push({
          guid: item.guid,
          name: item.organisationName,
          objectType: item.nodeType == '1' ? '组织' : '人员'
        })
      });
      if (organisationInfo.length == 0) return;
      let query = {
        tenantGuid: this.sendTenantGuid,//派发药企
        // organisationInfo:!isIncludePeople?JSON.stringify(organisationInfo):null,//派发组织
        organisationInfo: JSON.stringify(organisationInfo),
        timeType: this.timeType,//发布周期
        startTime: this.startTime,//开始时间
        endTime: this.endTime,//结束时间
        taskType: this.taskType,//模版类型
        type: 1,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/template/init-template-name`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskTitle = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });

    },
    //获取模版名称
    getTemplteName() {
      let self = this;
      let organisationInfo = [];
      this.departmentListII.forEach((item) => {
        organisationInfo.push({
          guid: item.guid,
          name: item.organisationName,
          objectType: item.nodeType == '1' ? '组织' : '人员'
        });
      });
      let query = {
        tenantGuid: this.sendTenantGuid,
        organisationInfo: JSON.stringify(organisationInfo),
        taskType: this.taskType,
        type: 2,
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/template/init-template-name`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.newTemplateName = res.data.data;
          self.$confirm(`任务模版名称为【${self.newTemplateName}】`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              self.saveTemplate();
            })
        } else {
          self.$message.error(res.data.msg);
        }
      });

    },
    delWaitList(guids) {
      guids.forEach(i => {
        this.tableDataII.forEach((j, k) => {
          if (i == j.guid) {
            this.tableDataII.splice(k, 1);
          }
        })
      })
    },
    delItem(index) {
      this.tableDataII.splice(index, 1);
    },
    handleSelectSuper(v) {
      this.tempSuperTemplate = v;
    },
    handleClickSuper(row, col, event) {
      row.flag = !row.flag;
      this.$refs.superTable.toggleRowSelection(row, row.flag);
    },
    openTemplate() {
      if (!this.sendTenantName) {
        this.$message.error('请先选择委托方');
        return;
      }
      this.visible4 = true;
      this.getSchemeTemplateList();
      this.getSuperTemplateList();
      // this.getSuperTemplateGuid();
      this.getContractList();
    },
    tableClick() {
      if(this.$refs.contractTable){
        this.$refs.contractTable.clearSelection();
      }
      if(this.$refs.superTable){
        this.$refs.superTable.clearSelection();
      }
      this.tempSuperTemplate = [];
    },
    cancelChooseTemplate() {
      this.emptySearchSuper();
      this.emptySearchScheme();
      this.visible4 = false;
    },
    //确定选中模版
    sureChooseTemplate() {
      var tableData = this.$refs.templateConfig.tableData;
      console.log(tableData,'tableData')
      setTimeout(()=>{
        if (!this.templateSelectd && this.tempSuperTemplate.length == 0) {
          this.$message.error('请选择模版');
          return;
        }
        if (this.activeTemlate == '0' || this.activeTemlate == '2') {
          //超级模版
          if (this.tableDataII.length == 0) {
            this.tableDataII = this.tempSuperTemplate;
            this.tableDataII.forEach((item, index) => {
              item.parentTemplateDetailName = item.taskContentName;
              item.parentTemplateDetailGuid = item.guid
              item.taskContentName=this.activeTemlate == '2'?item.tenantTaskContentName:item.taskContentName
              item.taskPrice = this.taskPriceModel == '2' ? item.staffBasePrice : item.taskPrice
            })
          } else {
            this.tableDataII.forEach((item, index) => {
              tableData[index]['taskTotalOrigin'] = item.taskTotalOrigin;
            })
            var tempSuperTemplate = this.tempSuperTemplate;
            tempSuperTemplate.forEach(item => {
              item.parentTemplateDetailName = item.taskContentName;
              item.parentTemplateDetailGuid = item.guid;
              item.taskContentName=this.activeTemlate == '2'?item.tenantTaskContentName:item.taskContentName
              item.taskPrice = this.taskPriceModel == '2' ? item.staffBasePrice : item.taskPrice
              tableData.push(item);
            })
            this.tableDataII = tableData;
          }
          this.orignTableII = this.tableDataII;
          this.serviceTenantName = JSON.parse(localStorage.userInfo).tenantName;
          this.serviceTenantGuid = localStorage.guid;
          this.templateGuid = this.superTemplateGuid;
          this.tableDataII.forEach((item) => {
            if (item.goodsInfo||item.multipleSelection) {
              item.goodsInfo = JSON.stringify(item.goodsInfo||item.multipleSelection);
            }
          });
          this.getDiscountRatio(false)
          this.tempSuperTemplate = [];
          setTimeout(() => {
            this.$refs.templateConfig.getPlanCount();
          }, 200)
        } else {
          //普通模版
          this.chooseTemplate = this.templateSelectd;
          this.getTemplateDetail(this.chooseTemplate.guid);
        }
      },200)
      this.emptySearchSuper();
      this.emptySearchScheme();

      this.visible4 = false;
    },
    //获取折扣比例
    getDiscountRatio(type) {
      console.log(this.tableDataII)
      let templateDetailGuid = [];
      this.tableDataII.forEach(item => {
        templateDetailGuid.push(type ? item.parentTemplateDetailGuid : item.guid)
      })
      let query = {
        templateDetailGuid,
        serviceTenantGuid: this.serviceTenantGuid,
        tenantGuid: this.sendTenantGuid,
      };
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/template/get-discount-ratio`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          res.data.data.forEach((item, index) => {
            this.tableDataII[index].discountRatio = "";
            this.tableDataII[index].floatDiscountRatio = this.tableDataII[index].floatDiscountRatio||item.discountRatio
          })
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleChangeCompany(v) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: v,
        sendTenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //单选实现
    handleSelectScheme(selection, row) {
      this.templateSelectd = '';
      this.$refs.dataTable.clearSelection();
      this.templateSelectd=''
      if (selection.length == 0) {
        return;
      }
      if (row) {
        this.templateSelectd = row;
        this.$refs.dataTable.toggleRowSelection(row, true);
      }
    },
    handleClickScheme(row, col, event) {
      this.$refs.dataTable.clearSelection();
      row.flag = !row.flag;
      this.$refs.dataTable.toggleRowSelection(row, row.flag);
      this.templateSelectd = row;
    },
    getSendTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.sendTenantList = res.data.data;
            if (!self.$route.query.guid && self.sendTenantList.length == 1) {
              self.sendTenantName = self.sendTenantList[0].sendTenantName;
              self.sendTenantGuid = self.sendTenantList[0].sendTenantGuid;
              self.getOrganisation(self.sendTenantGuid);
              this.api.get('/ms-customer-service/tenant-expand/get-medicine-enterprise-detail?tenantGuid=' + this.sendTenantGuid).then((res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                  this.taskPriceModel = res.data.data.taskPriceModel;
                }
              })
              
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              ['每个品种的任务量 = 任务量除以品种个数'],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    //获取项目模版
    getSchemeTemplateList(type) {
      if (this.sendTenantGuid) {
        this.schemPage.sendTenantGuid = this.sendTenantGuid;
      }
      if (type) {
        this.schemPage.pageIndex = 1;
        this.schemPage.pageSize = 50;
      }
      let self = this;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/task-set/template/get-list`, this.schemPage)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.schemeTemplateList = res.data.data.records;
            self.schemPage.totalPage = res.data.data.totalPages;
            self.schemPage.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    emptySearchScheme() {
      this.schemPage = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        isUse: 'Y',
        tenantName: '', //药企名称
        templateName: '', //模版名称
        sendTenantGuid: '',
        tenantGuid: localStorage.guid,
        serviceTenantGuid: localStorage.guid,
        organisationInfo: '',
      };
      this.getSchemeTemplateList();
    },
    handleSizeChange(val) {
      let self = this;
      self.schemPage.pageSize = val;
      this.getSchemeTemplateList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.schemPage.pageIndex = val;
      this.getSchemeTemplateList();
    },
    handleSizeChange1(val) {
      let self = this;
      self.superPage.pageSize = val;
      this.getSuperTemplateList();
    },
    handleCurrentChange1(val) {
      let self = this;
      self.superPage.pageIndex = val;
      this.getSuperTemplateList();
    },
    handleSizeChange2(val) {
      let self = this;
      self.contractPage.pageSize = val;
      this.getContractTemplateList();
    },
    handleCurrentChange2(val) {
      let self = this;
      self.contractPage.pageIndex = val;
      this.getContractTemplateList();
    },

    //获取超级模版
    getSuperTemplateList(type) {
      if (type) {
        this.superPage = {
          isSuper: 'Y',
          pageIndex: 1,
          pageSize: 50,
          totalPage: 0,
          totalRows: 0,
          bizState: 'Y',
          taskContentName: !this.superPage.taskContentName ? null : Array.isArray(this.superPage.taskContentName) ? this.superPage.taskContentName : [this.superPage.taskContentName],
          menuName: this.superPage.menuName
        }
      }
      var self = this;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/template/detail/get-detail-page-list`, this.superPage)
        .then((res) => {
          if (res.data.code != '00000') {
            this.$message.error(res.data.msg);
            return;
          }
         
          self.superTemplateList = res.data.data?res.data.data.records:[];
          self.superPage.totalRows =  res.data.data?res.data.data.totalRows:0
          self.superPage.totalPage = res.data.data?res.data.data.totalPages:0;
          if (!self.superTemplateList) return;
          self.superTemplateList.forEach(item => {
            item.taskTotalOrigin = item.taskTotal
            this.superTemplateGuid = item.templateGuid;
          });
        });
    },
    //获取超级模版GUID和名字
    // getSuperTemplateGuid() {
    //   let req = {
    //     isSuper: 'Y'
    //   }
    //   this.api
    //     .postJson(`/${serverConfig.msSalesPerformService}/task-set/template/get-detail`, req)
    //     .then((res) => {
    //       this.superTemplateName = res.data.data.templateName;
    //       this.superTemplateGuid = res.data.data.guid;
    //     });
    // },
    //清空超级模版查询条件
    emptySearchSuper() {
      this.superPage = {
        isSuper: 'Y',
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        bizState:'Y',
        taskContentName: null, //任务名称
        menuName: '', //菜单名称
      };
      this.getSuperTemplateList();
    },

    //获取模版详情
    getTemplateDetail(guid) {
      var self = this;
      var req = {
        templateGuid: guid,
        pageSize: -1,
        pageIndex: 1,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/template/get-detail`, req).then((res) => {
        if (res.data.code != '00000') {
          this.$message.error(res.data.msg);
          return;
        }
        if (!this.tableDataII || !this.tableDataII.length) {
          this.tableDataII = res.data.data.detailList;
          self.tableDataII.forEach((item) => {
            item.taskTotalOrigin = item.taskTotal
          });
        } else {
          var tableData = this.$refs.templateConfig.tableData;
          this.tableDataII.forEach((item, index) => {
            tableData[index].taskTotalOrigin = item.taskTotalOrigin;
          })
          var detailList = res.data.data.detailList;
          detailList.forEach(item => {
            item.taskTotalOrigin = item.taskTotal
            tableData.push(item);
          })
          this.tableDataII = tableData;
        }

        self.orignTableII = this.tableDataII;
        self.serviceTenantName = res.data.data.serviceTenantName;
        self.serviceTenantGuid = res.data.data.serviceTenantGuid;
        self.sendTenantName = res.data.data.tenantName;
        self.sendTenantGuid = res.data.data.tenantGuid;
        if (this.departmentListII.length == 0) {
          self.getOrganisation(self.sendTenantGuid);
          // self.getOrganisationII(self.sendTenantGuid);
          var organisationInfo = JSON.parse(res.data.data.organisationInfo);
          var departmentListII = [];
          organisationInfo.forEach((item) => {
            departmentListII.push({
              guid: item.guid,
              organisationName: item.name,
              nodeType: item.objectType == '组织' || !item.objectType ? '1' : '2'
            });
          });
          self.organisationInfo = res.data.data.organisationInfo;
          this.departmentListII = departmentListII;
        }
        self.templateGuid = res.data.data.guid;
        this.tableDataII.forEach((item) => {
          if (item.goodsInfo) {
            var goodsInfo = JSON.parse(item.goodsInfo);
            goodsInfo.forEach((el) => {
              el.goodsCount = Math.ceil(item.taskTotal / goodsInfo.length);
            });
            item.goodsInfo = JSON.stringify(goodsInfo);
          }
        });
        this.getDiscountRatio(true)
        setTimeout(() => {
          this.$refs.templateConfig.getPlanCount();
        }, 200)
      });

    },
    //获取合同
    getContractList() {
      let req = {
        pageIndex: 1,
        pageSize: -1,
        approveState: 'Y',
        serviceTenantGuid: localStorage.guid,
        tenantGuid: this.sendTenantGuid,
        isRemoveInvalidity:'Y'
      }
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msCustomerService}/contract/list`, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.contractList = res.data.data.records;
          this.contractPage.guid = !this.contractList ? null : this.contractList[0].guid;
          if (this.contractPage.guid) {
            this.getContractTemplateList(true);
          }
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    getContractTemplateList(type) {
      if (type) {
        this.contractPage = {
          guid: this.contractPage.guid,
          bizState:'Y',
          pageIndex: 1,
          pageSize: 50,
          totalPage: 0,
          totalRows: 0,
          taskContentName: this.contractPage.taskContentName,
          oldTaskContentName: this.contractPage.oldTaskContentName,
        }
      }
      let self = this;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/task-set/template/get-contract-task-template-list`, this.contractPage)
        .then((res) => {
          if (res.data.code != '00000') {
            this.$message.error(res.data.msg);
            return;
          }
          self.contractTemplateList = res.data.data && res.data.data.records || [];
          self.contractPage.totalRows = res.data.data && res.data.data.totalRows || 0;
          self.contractPage.totalPage = res.data.data && res.data.data.totalPages || 0;
          if (!self.contractTemplateList) return;
          self.contractTemplateList.forEach((item) => (item.taskTotalOrigin = item.taskTotal));
        });
    },
    emptySearchContract() {
      this.contractPage = {
        guid: this.contractPage.guid,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        taskContentName: null,
        oldTaskContentName: null,
      }
      this.getContractTemplateList(true)
    },
    handleSelectContract(list) {
      list.forEach(item=>{
        item.guid = item.templateDetailGuid
      })
      this.tempSuperTemplate = list;
    },
    handleClickContract(row, col, event) {
      row.flag = !row.flag;
      this.$refs.contractTable.toggleRowSelection(row, row.flag);
    },
    //选择发布人员
    addPeople() {
      if (!this.sendTenantName) {
        this.$message.error('请选择委托方');
        return;
      }
      if (this.disabled) return;
      this.visible3 = true;
    },
    //获取任务包详情
    getDetail() {
      var self = this;
      if (!this.$route.query.guid) {
        this.getApprovalList();
        return;
      }
      if (this.$route.query.is_edit) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
      var req = {
        guid: this.$route.query.guid,
      };
      this.fullscreenLoading = true;
      self.api.get(`/${serverConfig.msSalesPerformService}/task/data/get-detail`, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          var detail = res.data.data;
          this.detail = res.data.data;
          this.getApprovalList();
          var taskTitle = detail.taskTitle;
          var nextDay = detail.nextDay;
          var orderType = detail.orderType;
          var regex = /\((.+?)\)/g;
          this.taskPriceModel = detail.taskPriceModel;
          this.timeType = detail.timeType;
          this.autoForecastOpen = detail.autoForecastOpen;
          if (this.autoForecastOpen == '1' && detail.autoForecastJson) {
            this.autoForecastJson = JSON.parse(detail.autoForecastJson);
          }
          if (taskTitle.indexOf('(') > -1) {
            this.newTaskTitleTxt = taskTitle.match(regex)[0].replace("(", "").replace(")", "");
            this.taskTitle = taskTitle.split('(')[0];
          } else {
            this.taskTitle = taskTitle;
          }
          this.taskType = this.detail.taskType;
          // 数据标注扩展回显（N7 行级化：按明细行 taskContentType=SJBZ 逐行回填——数据集多选=各行 datasetGuid；
          // 旧包无行级数据时回退包级 labelConfig 兼容）；留比对快照供"确认时可修改"变更比对
          const allLabelRows = (this.detail.taskDetailList || []).filter((row) => row.taskContentType === 'SJBZ');
          const labelRows = allLabelRows.filter((row) => row.labelConfig);
          this.originalLabelSources = allLabelRows.map((row) => {
            if (row.labelConfig) this.$set(row, '_sourceTaskDetailGuid', row.guid || '');
            try {
              if (!row.labelConfig) throw new Error('缺少原标注配置');
              const config = JSON.parse(row.labelConfig);
              if (!config || typeof config !== 'object' || Array.isArray(config)
                || (config.datasetGuid != null && typeof config.datasetGuid !== 'string')) throw new Error('原标注配置无效');
              return { detailGuid: row.guid || '', datasetGuid: config.datasetGuid || '', labelConfig: config,
                taskContentName: row.taskContentName || '', taskTotalUnit: row.taskTotalUnit || '' };
            } catch (e) {
              return { detailGuid: row.guid || '', datasetGuid: null,
                taskContentName: row.taskContentName || '', taskTotalUnit: row.taskTotalUnit || '' };
            }
          });
          let labelSource = null;
          let rowConfigs = [];
          try {
            rowConfigs = labelRows.map((row) => JSON.parse(row.labelConfig));
            labelSource = rowConfigs.length ? rowConfigs[0]
              : (this.detail.labelConfig ? JSON.parse(this.detail.labelConfig) : null);
          } catch (e) {
            console.log('labelConfig parse error', e);
          }
          this.originalLabelSnapshotInvalid = [...rowConfigs, labelSource].some((config) => config
            && hasInvalidTaskSnapshots(config));
          if (labelSource) {
            this.labelForm = {
              ...this.labelForm,
              ...labelSource,
              datasetGuids: rowConfigs.length
                ? rowConfigs.map((c) => c && c.datasetGuid).filter(Boolean)
                : (labelSource.datasetGuid ? [labelSource.datasetGuid] : []),
              qcRatio: labelSource.qcRatio != null ? String(labelSource.qcRatio) : '100',
              labelSnapshots: this.originalLabelSnapshotInvalid ? [null]
                : (Array.isArray(labelSource.labelSnapshots) && labelSource.labelSnapshots.length
                  ? labelSource.labelSnapshots
                  : (labelSource.labelSnapshot ? [labelSource.labelSnapshot] : [null])),
              titleGuids: labelSource.titleGuids || [],
            };
            this.labelConfigRaw = this.buildLabelCompareSnapshot();
            // 数据集可能已流转非待标注状态（不在候选列表），补项保留下拉回显（防 loadLabelOptions 后到覆盖）
            this.ensureDatasetOption();
          }
          if (orderType == 1 || !orderType) {
            this.orderType = '1';
            this.isNextDay = false;
            this.nextDay = '';

          }
          if (orderType == 2) {
            this.orderType = '2';
            this.isNextDay = true;
            this.nextDay = nextDay;
          }

          setTimeout(() => {
            this.startTime = moment(detail.startTime).format('YYYY-MM-DD');
            this.endTime = moment(detail.endTime).format('YYYY-MM-DD');
            if(detail.timeType=='按年'){
              this.year=detail.startTime.substr(0, 4);
            }
            if(detail.timeType=='自定义'){
              this.timeRange=[this.startTime , this.endTime];
            }
            if(detail.timeType=='按月'&&detail.month){
              this.month=detail.month.substr(0, 4) + "-" + detail.month.substr(4, 2);
            }
          }, 100);
          this.departmentData = [
            {
              staffName: detail.senderStaffName,
              guid: detail.senderStaffGuid,
            },
          ];
          this.departmentList = [
            {
              staffName: detail.senderStaffName,
              guid: detail.senderStaffGuid,
            },
          ];
          this.getOrganisation(detail.tenantGuid);
          // this.getOrganisationII(detail.tenantGuid);
          //执行部门
          if (detail.organisationInfo) {
            var departmentListII = [];
            var organisationInfo = JSON.parse(detail.oldOrganisationInfo || detail.organisationInfo);
            organisationInfo.forEach((item) => {
              departmentListII.push({
                guid: item.guid,
                organisationName: item.name,
                nodeType: item.objectType == '组织' || !item.objectType ? '1' : '2'
              });
            });
            this.organisationInfo = detail.organisationInfo;
            this.departmentListII = departmentListII;
          }
          this.tableDataII = detail.taskDetailList || [];
          this.templateGuid = detail.templateGuid;
          this.templateName = detail.templateName;
          this.serviceTenantName = detail.serviceTenantName;
          this.serviceTenantGuid = detail.serviceTenantGuid;
          this.sendTenantName = detail.tenantName;
          this.sendTenantGuid = detail.tenantGuid;
          this.tableDataII.forEach(item => {
            if (item.taskTotalType == '固定量人均') {
              item.taskTotal = item.taskAvg;
            }
            if (item.surveyTenantGuid) {
              item.surveyObj = {
                surveyTenantGuid: item.surveyTenantGuid,
                surveyTitle: item.surveyTitle
              }
            }
          })
          var req = {
            taskID: this.$route.query.guid,
          };
          this.api.get(`/${serverConfig.msSalesPerformService}/task-set/template/get-template-detail-list`, req).then((res) => {
            this.tableDataII.forEach((i, j) => {
              res.data.data.forEach((k, l) => {
                if (i.templateDetailGuid == k.guid) {
                  i.taskTotalOrigin = k.taskTotal;
                  i.guid = k.guid;
                  i.parentTemplateDetailName = k.parentTemplateDetailName || i.parentTemplateDetailName;
                  i.parentTemplateDetailGuid = k.parentTemplateDetailGuid || i.parentTemplateDetailGuid;
                }
              })
            })
            this.orignTableII = this.tableDataII;
          });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //确认发布
    submitReq(type) {
      if (this.timeType == '自定义' && this.timeRange) {
        this.startTime = this.timeRange[0];
        this.endTime = this.timeRange[1];
      }
      if (this.disabled) return;
      let self = this;
      let isTips = [];
      if (!this.sendTenantName) {
        this.$message.error('请选择委托方');
        return;
      }
      if (this.departmentList.length == 0) {
        this.$message.error('请选择发布人员');
        return;
      }
      if (this.departmentListII.length == 0) {
        this.$message.error('请选择执行部门');
        return;
      }
      if (!this.startTime) {
        this.$message.error('请选择时间');
        return;
      }
      // FOUR-3009：按月任务核算月份必填（此前无校验，month 为 null 时提交链路 replace 直接崩）
      if (this.timeType == '按月' && !this.month) {
        this.$message.error('请选择核算月份');
        return;
      }
      // 数据标注类型走独立提交链路（无传统任务模版明细，扩展字段见 submitLabelTask）
      if (this.isLabelTask) {
        this.submitLabelTask(type);
        return;
      }
      if (this.tableDataII.length == 0 && type == 1) {
        this.$message.error('请选择任务模版');
        return;
      }
      //超龄弹层出现
      if (this.openOrgAlert) {
        this.getOverAgeList();
        return;
      }

      const userinfo = JSON.parse(localStorage.userInfo);

      var taskTotalUnitList = this.$refs.templateConfig.taskTotalUnitList;
      var tableDataII = this.$refs.templateConfig.tableData;

      var departmentList = this.departmentList;
      var senderStaffGuid = departmentList[0].guid;
      var senderStaffName = departmentList[0].staffName;
      var tenantName = this.sendTenantName;
      var tenantGuid = this.sendTenantGuid;
      var templateGuid = this.templateGuid;
      var detailParam = [];
      var organisationInfo = [];
      this.departmentListII.forEach((item) => {
        organisationInfo.push({
          guid: item.guid,
          name: item.organisationName,
          objectType: item.nodeType == '1' ? '组织' : '人员'
        });
      });
      try {
        tableDataII.forEach((el, orderIndex) => {
          var detail = {
            taskContentName: '', //任务名称名称
            taskContentGuid: '', //任务名称GUID
            taskContentType: '', //任务名称类别
            taskType: '', //任务大类
            taskTypeGuid: '', //任务大类Guid
            taskTotal: '', //任务总量
            taskTotalUnit: '', //任务总量单位
            taskTotalUnitGuid: '',

            taskPrice: '', //任务价格
            taskPriceUnit: '',
            taskPriceUnitGuid: '',

            menuUrl: '', //菜单地址
            taskContentJson: '',
            menuName: '', //菜单名称
            taskTotalType: '', //任务总量类型(????)

            staffWorkNote: '', //业务员工作要求
            staffTaskNote: '', //业务员任务文案
            tenantWorkNote: '', //药企工作要求
            tenantTaskNote: '', //药企任务文案
            countRule: '', //统计规则
            organisationInfo: JSON.stringify(organisationInfo),
            clientObject: null, //客户对象json
            clientArea: '', //客户区域json
            clientAreaLabel: [],
            goodsInfo: '', //商品信息json
            taskIcon: '', //	string任务图标json

            settleRule: "1", //1单价 2比例
            settlePercent: null,

            isAskClock: '', //是否要求打卡 是/否
            isAskPhoto: '', //是否要求拍照 是/否
            minAskPhoto: '', //最少要求拍照数量
            isAskUpload: '', //是否要求上传资料 是/否
            minAskUpload: '', //最少上传资料数量

            isOpenMaxTask: 'Y', //是否开启超量上限拦截
            maxTaskValue: 0,  // 超量限制

            orderIndex: orderIndex + 1,
            templateDetailGuid: el.guid,
            isTeamLeader: '',
            isAllowTenantUse: '',
            menuRemark: '',
            parentTemplateDetailGuid: '',
            parentTemplateDetailName: '',

            taskLabel: '',
            surveyLabelList: el.surveyLabelList,
          };
          // N7 行级化：标注行（SJBZ）走行级契约——必填=质检比例/更多三域/标签模板，
          // 跳过普通行的大类/报价/统计规则/打卡拍照上传等校验（与后端 createTaskDetailList SJBZ 跳过逻辑对齐）
          if (el.taskContentType === 'SJBZ') {
            let sjbzConf = {};
            try {
              sjbzConf = el.labelConfig ? JSON.parse(el.labelConfig) : {};
            } catch (e) {
              throw new Error(`【${el.taskContentName || '标注行'}】原任务标签快照格式异常，请核查原任务后重试`);
            }
            if (hasInvalidTaskSnapshots(sjbzConf)) {
              throw new Error(`【${el.taskContentName || '标注行'}】原任务标签快照格式异常，请核查原任务后重试`);
            }
            // FOUR-3010：协配端数据集可空（药企 ES 端自建必填），不再拦截"请选择标注数据"
            const sjbzRatio = +sjbzConf.qcRatio;
            if (!Number.isInteger(sjbzRatio) || sjbzRatio <= 0 || sjbzRatio > 100) {
              throw new Error(`【${el.taskContentName || '标注行'}】质检比例须为 0~100 的整数`);
            }
            if (!(sjbzConf.labelSnapshots || []).length && !sjbzConf.labelSnapshot) {
              throw new Error(`【${el.taskContentName || '标注行'}】请在标注人员要求中选择标签模板`);
            }
            // 项目标签与普通行同口径必填（普通行见下方"请选择标签"校验，SJBZ 块提前 return 需在此补齐）
            if (!(el.surveyLabelList || []).length) {
              throw new Error(`【${el.taskContentName || '标注行'}】请选择标签`);
            }
            if (!el.staffTaskNote || !el.tenantTaskNote || !el.staffWorkNote) {
              throw new Error(`【${el.taskContentName || '标注行'}】请在更多中填写工作内容描述/工作内容明细/任务管理要求`);
            }
            // 口径3 任务量必填/非零：SJBZ 分支下方提前 return，普通行 2811-2816 的任务量校验对本分支
            // 不可达，此处补齐（仅系统计算/固定量人均两态有输入框，与普通行同条件；不限量等无输入
            // 不校验；autoForecastOpen!='0' 时输入框不渲染，与普通行 :2814 同条件放行）
            if (this.autoForecastOpen == '0' && (el.calcType == '系统计算' || el.calcType == '固定量人均')) {
              if (el.taskTotal == null || el.taskTotal === '') {
                throw new Error(`【${el.taskContentName || '标注行'}】请填写任务量`);
              }
              if (+el.taskTotal === 0) {
                throw new Error(`【${el.taskContentName || '标注行'}】限量的任务量不能为0`);
              }
            }
            detail.taskContentName = el.taskContentName;
            detail.taskContentType = 'SJBZ';
            // 模版来源行携带大类，必须透传——老链路 checkTemplateTaskAdd 校验模板明细与提交行
            // 的 taskType/taskTypeGuid 一致（漏带空串必炸 S0017"模板任务类型与超级模板任务大类不一致"）
            detail.taskType = el.taskType;
            detail.taskTypeGuid = el.taskTypeGuid;
            // JSON 列置 null：tr_task_detail 的 task_content_json/goods_info 等 json 列空串会炸
            // "Invalid JSON text: The document is empty."（基础 detail 对象默认 '' 不能带，全部 null 守卫）
            detail.taskContentJson = null;
            detail.goodsInfo = null;
            // ===== 表格标准列全量携带（与普通路径逐字段对齐；明细表这些列对 SJBZ 行同样可编辑）=====
            // 报价两 trio + 区间价/折扣（区间价随 taskPriceModel）
            detail.tenantTaskPrice = el.tenantTaskPrice;
            detail.tenantTaskPriceUnit = el.tenantTaskPriceUnit;
            detail.tenantTaskPriceUnitGuid = el.tenantTaskPriceUnitGuid;
            detail.taskPrice = el.taskPrice;
            detail.taskPriceUnit = el.taskPriceUnit;
            detail.taskPriceUnitGuid = el.taskPriceUnitGuid;
            detail.tenantMinPrice = this.taskPriceModel == 2 ? el.tenantMinPrice : null;
            detail.tenantMaxPrice = this.taskPriceModel == 2 ? el.tenantMaxPrice : null;
            detail.discountRatio = this.taskPriceModel == 2 ? el.discountRatio : null;
            detail.floatDiscountRatio = this.taskPriceModel == 2 ? el.floatDiscountRatio : null;
            detail.staffBasePrice = el.staffBasePrice;
            detail.ruleCoefficient = el.ruleCoefficient;
            // 任务量路由按计算方式分流（2026-09-29 拍板计算方式不写死）：固定量人均=以量定人，
            // 人均进 taskAvg、taskTotal 置 null 由后端三锚点按数据集条数回填（SJBZ 永不乘人数，
            // 与普通行"以人定量"方向相反）；系统计算=总量语义（输入框值=标注数据带出的数据量），
            // 直接走 taskTotal 不涉及人均
            if (el.calcType == '固定量人均') {
              detail.taskAvg = el.taskTotal != null && el.taskTotal !== '' ? el.taskTotal : null;
              detail.taskTotal = null;
            } else {
              detail.taskAvg = null;
              detail.taskTotal = el.taskTotal != null && el.taskTotal !== '' ? el.taskTotal : null;
            }
            detail.taskTotalUnit = el.taskTotalUnit || sjbzConf.dataUnit || '';
            detail.taskTotalUnitGuid = el.taskTotalUnitGuid;
            // 计算方式（普通路径同源：el.calcType → taskTotalType）
            detail.taskTotalType = el.calcType;
            detail.settleRule = el.settleRule;
            detail.settlePercent = el.settlePercent;
            if (el.isOpenMaxTask == 'Y') {
              if (el.maxTaskValue >= 0 && el.maxTaskValue <= 100) {
                detail.isOpenMaxTask = 'Y';
                detail.maxTaskValue = +el.maxTaskValue;
              } else {
                throw new Error(`【${el.taskContentName || '标注行'}】请填写正确上限百分比`);
              }
            } else {
              detail.isOpenMaxTask = 'N';
              detail.maxTaskValue = 0;
            }
            taskTotalUnitList.forEach((item) => {
              if (item.guid == el.taskTotalUnitGuid) {
                detail.countRule = item.paramValue1;
              }
            });
            // 打卡要求/拍照要求/上传资料（含最少数量）
            detail.isAskClock = el.isAskClock;
            detail.isAskPhoto = el.isAskPhoto;
            detail.minAskPhoto = el.minAskPhoto;
            detail.isAskUpload = el.isAskUpload;
            detail.minAskUpload = el.minAskUpload;
            // 编码/分类/中类/常规任务/终端类型/问卷/菜单与根模版（json 列 null 守卫）
            detail.taskCode = el.taskCode || '';
            detail.goodsCategoryJson = el.goodsCategoryJson || null;
            detail.marketingCategoryJson = el.marketingCategoryJson || null;
            detail.staffCategoryJson = el.staffCategoryJson || null;
            detail.taskCategory = el.taskCategory || null;
            detail.taskMediumType = el.taskMediumType || '';
            detail.isNormalTask = el.isNormalTask || '';
            detail.terminalTypeClassificationJson = el.terminalTypeClassificationJson || null;
            detail.taskContentGuid = el.taskContentGuid;
            detail.menuUrl = el.menuUrl;
            detail.menuName = el.menuName;
            detail.menuRemark = el.menuRemark;
            detail.isTeamLeader = el.isTeamLeader;
            detail.isAllowTenantUse = el.isAllowTenantUse;
            detail.parentTemplateDetailGuid = el.parentTemplateDetailGuid;
            detail.parentTemplateDetailName = el.parentTemplateDetailName;
            detail.surveyTenantGuid = el.surveyObj && el.surveyObj.surveyTenantGuid || null;
            detail.clientObject = el.clientObject || null;
            // 客户区域（更多弹框可编辑，与普通路径同款序列化；默认不限区域）
            var sjbzClientArea = [];
            if (el.clientAreaRadio == '指定区域' && el.clientArea && el.clientArea.length) {
              el.clientArea.forEach((item, index) => {
                sjbzClientArea.push({ name: el.clientAreaLabel[index], guid: item[1], provinceCode: item[0] });
              });
            } else {
              sjbzClientArea.push({ name: (el.clientAreaRadio == '本区域' ? '本区域' : '不限区域'), guid: '' });
            }
            detail.clientArea = JSON.stringify(sjbzClientArea);
            // 任务标签/图标（标注行不强制，有则带）
            detail.taskTag = el.taskTag && el.taskTag.length ? JSON.stringify(el.taskTag) : null;
            detail.taskLabel = el.taskLabel && el.taskLabel.length ? JSON.stringify(el.taskLabel) : null;
            detail.taskIcon = el.fileList && el.fileList.length ? JSON.stringify(el.fileList) : null;
            // 文案四件套
            detail.labelConfig = el.labelConfig;
            if (this.$route.query.guid && el._sourceTaskDetailGuid) {
              detail.sourceTaskDetailGuid = el._sourceTaskDetailGuid;
            }
            detail.staffTaskNote = el.staffTaskNote;
            detail.tenantTaskNote = el.tenantTaskNote;
            detail.tenantWorkNote = el.tenantWorkNote;
            detail.staffWorkNote = JSON.stringify(el.staffWorkNote.split('\n'));
            detailParam.push(detail);
            return;
          }
          //根模版
          detail.parentTemplateDetailGuid = el.parentTemplateDetailGuid;
          detail.parentTemplateDetailName = el.parentTemplateDetailName;
          //任务大类
          detail.taskType = el.taskType;
          detail.taskTypeGuid = el.taskTypeGuid;

          if (!el.taskType && type == 1) {
            throw new Error('请选择任务大类');
          }
          //任务名称
          detail.taskContentGuid = el.taskContentGuid;
          detail.menuUrl = el.menuUrl;
          detail.taskContentJson = el.taskContentJson;
          
          //任务编码
          detail.taskCode = el.taskCode;
          //产品分类
          detail.goodsCategoryJson = el.goodsCategoryJson;
          //终端类型
          detail.terminalTypeClassificationJson = el.terminalTypeClassificationJson;
          //药企区间价
          detail.tenantMinPrice = this.taskPriceModel == 2 ? el.tenantMinPrice : null;
          detail.tenantMaxPrice = this.taskPriceModel == 2 ? el.tenantMaxPrice : null;
          //折扣比例
          detail.discountRatio =  this.taskPriceModel == 2 ? el.discountRatio:null;

          //浮动比例
          detail.floatDiscountRatio =  this.taskPriceModel == 2 ? el.floatDiscountRatio:null;

          //业务员基础报价
          detail.staffBasePrice = el.staffBasePrice;
          //规则系数
          detail.ruleCoefficient = el.ruleCoefficient;

          //市场分类
          detail.marketingCategoryJson = el.marketingCategoryJson;

          detail.staffCategoryJson = el.staffCategoryJson;
          detail.taskCategory = el.taskCategory;//任务分类
          //任务中类
          detail.taskMediumType = el.taskMediumType;
          //是否常规任务
          detail.isNormalTask = el.isNormalTask;

          detail.isTeamLeader = el.isTeamLeader;
          detail.isAllowTenantUse = el.isAllowTenantUse;
          detail.menuName = el.menuName;
          detail.menuRemark = el.menuRemark;
          detail.taskContentType = el.taskContentType;
          detail.taskContentName = el.taskContentName;
          detail.clientObject = el.clientObject;
          if (!el.taskContentName && type == 1) {
            throw new Error('请选择任务名称');
          }


          detail.surveyTenantGuid = el.surveyObj && el.surveyObj.surveyTenantGuid || null;
          if (detail.menuUrl == '/subFillingApp/questionnaireFilling' && !detail.surveyTenantGuid) {
            throw new Error('请选择一个问卷');
          }

          detail.tenantTaskPrice = el.tenantTaskPrice;
          detail.tenantTaskPriceUnit = el.tenantTaskPriceUnit;
          detail.tenantTaskPriceUnitGuid = el.tenantTaskPriceUnitGuid;
          if (this.taskPriceModel == 1 && !el.tenantTaskPrice && type == 1) {
            throw new Error('请填写药企报价');
          }
          if (this.taskPriceModel == 2 && (!el.tenantMinPrice || !el.tenantMaxPrice) && type == 1) {
            throw new Error('请填写药企报价');
          }
          console.log('最低价：'+el.tenantMinPrice)
          console.log('最高价：'+el.tenantMaxPrice)
          console.log(+el.tenantMinPrice > +el.tenantMaxPrice)
          if (this.taskPriceModel == 2 && (+el.tenantMinPrice > +el.tenantMaxPrice) && type == 1) {
            throw new Error('药企区间价最高价需大于最低价');
          }
          if (this.taskPriceModel == 2 && (+el.tenantMinPrice == +el.tenantMaxPrice) && type == 1) {
            throw new Error('药企区间价最高价需大于最低价');
          }
          if (!el.tenantTaskPriceUnitGuid && type == 1) {
            throw new Error('请填写药企报价单位');
          }

          //业务员报价、业务员报价单位
          detail.taskPrice = el.taskPrice;
          detail.taskPriceUnit = el.taskPriceUnit;
          detail.taskPriceUnitGuid = el.taskPriceUnitGuid;
          if (!el.taskPrice && type == 1) {
            throw new Error('请填写业务员报价');
          }
          if (!el.taskPriceUnitGuid && type == 1) {
            throw new Error('请填写业务员报价单位');
          }
          if (el.taskPriceUnit.indexOf(el.taskTotalUnit) == -1) {
            // throw new Error(`【${el.taskContentName}】任务量单位与报价单位存在不一致的情况，请调整`);
            isTips.push(el.taskContentName);
          }

          //标准量、标准量单位
          detail.taskTotal = el.taskTotal;
          detail.taskTotalUnit = el.taskTotalUnit;
          detail.taskTotalUnitGuid = el.taskTotalUnitGuid;
          if (el.calcType == '不限量') {
            detail.taskTotal = 0;
          }
          if (el.calcType != '不限量' && el.taskTotal == 0) {
            throw new Error('限量的任务量不能为0');
          }
          if (this.autoForecastOpen == '0' && !el.taskTotal && (el.calcType == '固定量人均' || el.calcType == '系统计算')) {
            throw new Error('请填写任务量');
          }
          if (!el.taskTotalUnitGuid && type == 1) {
            throw new Error('请选择任务量单位');
          }

          if (el.isOpenMaxTask == 'Y') {
            if (el.maxTaskValue >= 0 && el.maxTaskValue <= 100) {
              detail.isOpenMaxTask = 'Y';
              detail.maxTaskValue = +el.maxTaskValue;
            } else {
              throw new Error('请填写正确上限百分比');
            }
          } else {
            detail.isOpenMaxTask = 'N';
            detail.maxTaskValue = 0;
          }

          detail.settleRule = el.settleRule;
          detail.settlePercent = el.settlePercent;

          if (!el.surveyLabelList?.length) {
            throw new Error('请选择标签');
          }

          detail.isAskClock = el.isAskClock;
          if (!el.isAskClock && type == 1) {
            throw new Error('请选择是否打卡');
          }
          detail.isAskPhoto = el.isAskPhoto;
          if (!el.isAskPhoto && type == 1) {
            throw new Error('请选择是否拍照');
          }
          detail.minAskPhoto = el.minAskPhoto;
          if (!el.minAskPhoto && el.isAskPhoto == '是') {
            throw new Error('请填写最少拍照数量');
          }
          detail.isAskUpload = el.isAskUpload;
          if (!el.isAskUpload && type == 1) {
            throw new Error('请选择是否上传资料');
          }
          detail.minAskUpload = el.minAskUpload;
          if (!el.minAskUpload && el.isAskUpload == '是' && type == 1) {
            throw new Error('请填写最少上传资料数');
          }
          //任务要求
          detail.taskTag = el.taskTag && el.taskTag.length ? JSON.stringify(el.taskTag) : null;

          //药企任务文案 、药企工作要求 运营任务文案 运营工作文案
          detail.staffWorkNote = JSON.stringify(el.staffWorkNote.split('\n'));
          detail.staffTaskNote = el.staffTaskNote;
          detail.tenantWorkNote = el.tenantWorkNote;
          detail.tenantTaskNote = el.tenantTaskNote;
          if (!el.tenantTaskNote && type == 1) {
            throw new Error('请至【更多内容编辑】中填写药企任务文案');
          }
          if (!el.staffTaskNote && type == 1) {
            throw new Error('请至【更多内容编辑】中填写运营方任务文案');
          }
          if (!el.staffWorkNote && type == 1) {
            throw new Error('请至【更多内容编辑】中填写运营方工作要求');
          }

          //客户区域
          var clientArea = [];

          if (el.clientAreaRadio == '本区域' || el.clientAreaRadio == '不限区域') {
            clientArea.push({
              name: el.clientAreaRadio,
              guid: '',
            });
          } else {
            if (!el.clientArea.length) {
              throw new Error('请选择客户区域');
            }
            el.clientArea.forEach((item, index) => {
              clientArea.push({
                name: el.clientAreaLabel[index],
                guid: item[1],
                provinceCode: item[0]
              });
            });
          }
          detail.clientArea = JSON.stringify(clientArea);

          //商品
          var goodsInfo = [];
          if (el.multipleSelection && el.multipleSelection.length != 0) {
            el.multipleSelection.forEach((i) => {
              goodsInfo.push({
                name: i.goodsName,
                guid: i.guid,
                goodsCount: Math.ceil(detail.taskTotal / el.multipleSelection.length),
                goodsUnit: i.unitStyle,
                goodsSpec: i.goodsSpec,
              });
            });
            detail.goodsInfo = goodsInfo.length == 0 ? null : JSON.stringify(goodsInfo);
          } else {
            detail.goodsInfo = null;
          }
          //任务要求
          detail.taskTag = el.taskTag&&el.taskTag.length? JSON.stringify(el.taskTag):null;

          //任务图标
          detail.taskIcon = JSON.stringify(el.fileList);
          if (el.fileList && el.fileList.length == 0 && type == 1) {
            throw new Error('请至【更多内容编辑】中上传任务图标');
          }

          //规则
          taskTotalUnitList.forEach((item) => {
            if (item.guid == el.taskTotalUnitGuid) {
              detail.countRule = item.paramValue1;
            }
          });

          //任务总量类型
          detail.taskTotalType = el.calcType;

          detail.taskLabel = el.taskLabel && el.taskLabel.length ? JSON.stringify(el.taskLabel) : null

          // detail.parentTemplateDetailGuid = this.orignTableII[orderIndex].parentTemplateDetailGuid;

          detailParam.push(detail);
        });
      } catch (e) {
        console.log(e)
        this.$message.error(e.message);
        return;
      }
      if (this.autoForecastOpen == '1' && type == 1) {
        this.autoForecastJson = {
          detailParam,
          parmValue1: this.getDepartmentName(this.departmentListII),
          parmValue2: '',
          parmValue3: ''
        }
        this.auoForeCastMoney();
        //开启智能预测
        return;
      }
      //预测后，将总量替换成预测的值
      if (type == 3) {
        var newDetailParam = this.autoForecastJson.detailParam;
        try {
          newDetailParam.forEach(item => {
            if (!item.taskTotalPercent) {
              throw new Error('任务占比不能为空');
            }
            if (!item.foreCastTaskTotal) {
              throw new Error('请先点击计算然后提交');
            }
          })
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
        newDetailParam.forEach(item => {
          if (item.foreCastTaskTotal) {
            item.taskTotal = item.foreCastTaskTotal
          }
        })
        detailParam = newDetailParam;
      }
      if (!this.ismobile) {
        this.$message.error('请选择应用端');
        return;
      }
      if (!this.isNextDay && this.orderType == 2) {
        this.$message.error('请勾选执行间隔');
        return;
      }
      if (!this.nextDay && this.orderType == 2) {
        this.$message.error('请填写间隔天数');
        return;
      }
      let req = {
        serviceTenantGuid: this.serviceTenantGuid,//服务商
        serviceTenantName: this.serviceTenantName,
        organisationInfo: JSON.stringify(organisationInfo),//下发组织
        taskTitle: this.taskTitle && this.newTaskTitleTxt ? this.taskTitle + '(' + this.newTaskTitleTxt + ')' : this.taskTitle,//包名
        tenantName,//药企
        tenantGuid,
        senderStaffGuid,//发布商
        senderStaffName,
        timeType: this.timeType,//发布周期
        startTime: this.startTime + ' 00:00:00',//开始时间
        endTime: this.endTime + ' 23:59:59',//结束时间
        templateGuid,//模版id
        detailParam,//包明细
        isService: 'Y',
        state: type == 0 ? '草稿中' : '待发布',//任务包状态
        autoForecastOpen: this.autoForecastOpen,//预测是否开启
        autoForecastJson: type == 3 ? JSON.stringify(this.autoForecastJson) : null,
        orderType: this.orderType,//执行顺序
        nextDay: this.orderType == 2 ? +this.nextDay : 0, //间隔天数
        month: this.timeType == '按月' ? (this.month || '').replace('-', '') || null : null,
        taskPriceModel: this.taskPriceModel,
        submitStaffGuid: userinfo.staffGuid,
        submitStaffName: userinfo.staffName,
        taskType: this.taskType,
      };
      let url = `/${serverConfig.msSalesPerformService}/task/data/add`;
      if (this.$route.query.guid) {
        req.guid = this.$route.query.guid;
        if (type != 0 && ((this.detail.bizApproveVO && this.detail.bizApproveVO.approveState == 'C') || (this.detail.bizApproveVO && this.detail.bizApproveVO.approveState == 'R'))) {
          req.guidResubmit = this.$route.query.guid;
        }
      }
      if (isTips.length > 0) {
        let tempTips = [];
        isTips.forEach(item => {
          tempTips.push('【' + item + '】')
        })

        self.$confirm(`${tempTips.join('、')}任务量单位与报价单位存在不一致的情况，建议再次检查一下，确定提交吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.fullscreenLoading = true;
          self.api.postJson(url, req).then((res) => {
            this.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              if (type == 0) {
                self.$message.success('保存成功');
              } else {
                self.$message.success(this.$route.query.guid ? '重新提交成功' : '新增成功');
              }
              this.$router.go(-1);
            } else {
              self.$message.error(res.data.msg);
            }
          });

        })
      } else {
        this.fullscreenLoading = true;
        self.api.postJson(url, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (type == 0) {
              self.$message.success('保存成功');
            } else {
              self.$message.success(this.$route.query.guid ? '重新提交成功' : '新增成功');
            }
            this.$router.go(-1);
          } else {
            self.$message.error(res.data.msg);
          }
        });

      }
    },
    confirmTemplate() {
      var self = this;
      if (!this.sendTenantName) {
        self.$message.error('请选择委托方');
        return;
      }
      if (this.departmentListII.length == 0) {
        self.$message.error('请选择执行部门');
        return;
      }

      if (!this.startTime) {
        self.$message.error('请选择时间');
        return;
      }
      if (!this.taskType) {
        self.$message.error('请选择任务类型');
        return;
      }

      if (this.tableDataII.length == 0) {
        self.$message.error('请选择任务模版');
        return;
      }
      var taskTotalUnitList = this.$refs.templateConfig.taskTotalUnitList;
      var tableDataII = this.$refs.templateConfig.tableData;
      var detailParam = [];
      var organisationInfo = [];
      this.departmentListII.forEach((item) => {
        organisationInfo.push({
          guid: item.guid,
          name: item.organisationName,
          objectType: item.nodeType == '1' ? '组织' : '人员'
        });
      });
      try {
        tableDataII.forEach((el, orderIndex) => {
          var detail = {
            surveyLabelList: el.surveyLabelList || [],
            taskContentName: '', //任务名称名称
            taskContentGuid: '', //任务名称GUID
            taskContentType: '', //任务名称类别
            taskType: '', //任务大类
            taskTypeGuid: '', //任务大类Guid
            taskTotal: '', //任务总量
            taskTotalUnit: '', //任务总量单位
            taskTotalUnitGuid: '',

            taskPrice: '', //任务价格
            taskPriceUnit: '',
            taskPriceUnitGuid: '',

            menuUrl: '', //菜单地址
            taskContentJson: '',
            menuName: '', //菜单名称
            taskTotalType: '', //任务总量类型(????)

            tenantTaskPrice: '',
            tenantTaskPriceUnit: '',
            tenantTaskPriceUnitGuid: '',
            tenantTaskContentName:'',
            activeTemlate:'',

            staffWorkNote: '', //业务员工作要求
            staffTaskNote: '', //业务员任务文案
            tenantWorkNote: '', //药企工作要求
            tenantTaskNote: '', //药企任务文案
            countRule: '', //统计规则
            organisationInfo: JSON.stringify(organisationInfo),
            clientObject: null, //客户对象json
            clientArea: '', //客户区域json
            goodsInfo: '', //商品信息json
            taskIcon: '', //	string任务图标json
            settleRule: '1',
            settlePercent: '',
            isAskClock: '', //是否要求打卡 是/否
            isAskPhoto: '', //是否要求拍照 是/否
            minAskPhoto: '', //最少要求拍照数量
            isAskUpload: '', //是否要求上传资料 是/否
            minAskUpload: '', //最少上传资料数量

            isOpenMaxTask: 'Y', //是否开启超量上限拦截
            maxTaskValue: 0,  // 超量限制

            orderIndex: orderIndex + 1,
            templateDetailGuid: el.guid,
            isTeamLeader: '',
            menuRemark: '',
            isAllowTenantUse: '',
            taskLabel: '',

            taskCode:'',//任务编码
            goodsCategoryJson:[],//产品分类
            marketingCategoryJson:[],//市场分类
            staffCategoryJson:[],//分类对象
            taskCategory:[],//任务分类
            taskMediumType:'',//任务中类
            isNormalTask:'',//是否常规任务
            terminalTypeClassificationJson:[],
            discountRatio:'',
            floatDiscountRatio:'',
            tenantMinPrice:'',
            tenantMaxPrice:'',
            staffBasePrice:'',
            ruleCoefficient:''
          };
          //任务大类
          detail.taskType = el.taskType;
          detail.taskTypeGuid = el.taskTypeGuid;

          if (!el.taskType) {
            throw new Error('请选择任务大类');
          }
          //任务名称
          detail.taskContentGuid = el.taskContentGuid;
          detail.menuUrl = el.menuUrl;
          detail.taskContentJson = el.taskContentJson;
          detail.menuRemark = el.menuRemark;
          detail.isTeamLeader = el.isTeamLeader;
          detail.menuName = el.menuName;
          detail.isAllowTenantUse = el.isAllowTenantUse;
          detail.taskContentType = el.taskContentType;
          detail.taskContentName = el.taskContentName;
          detail.clientObject = el.clientObject;




          //任务编码
          detail.taskCode = el.taskCode;
          //产品分类
          detail.goodsCategoryJson = el.goodsCategoryJson;
          //市场分类
          detail.marketingCategoryJson = el.marketingCategoryJson;

          detail.staffCategoryJson = el.staffCategoryJson;
          detail.taskCategory = el.taskCategory;//任务分类
          //任务中类
          detail.taskMediumType = el.taskMediumType;
          //是否常规任务
          detail.isNormalTask = el.isNormalTask;
             //终端类型
          detail.terminalTypeClassificationJson = el.terminalTypeClassificationJson;
          //药企区间价
          detail.tenantMinPrice = this.taskPriceModel == 2 ? el.tenantMinPrice : null;
          detail.tenantMaxPrice = this.taskPriceModel == 2 ? el.tenantMaxPrice : null;
          detail.discountRatio =  this.taskPriceModel == 2 ? el.discountRatio:null;
          detail.floatDiscountRatio =  this.taskPriceModel == 2 ? el.floatDiscountRatio:null;
          
          
          //业务员基础报价
          detail.staffBasePrice = el.staffBasePrice;
          //规则系数
          detail.ruleCoefficient = el.ruleCoefficient;


          if (!el.taskContentName) {
            throw new Error('请选择任务名称');
          }

          detail.tenantTaskPrice = el.tenantTaskPrice;
          detail.tenantTaskPriceUnit = el.tenantTaskPriceUnit;
          detail.tenantTaskPriceUnitGuid = el.tenantTaskPriceUnitGuid;
          detail.tenantTaskContentName = el.tenantTaskContentName;
          detail.activeTemlate = el.activeTemlate;
          detail.taskPriceModel = this.taskPriceModel;
          if (this.taskPriceModel == 1 && !el.tenantTaskPrice) {
            throw new Error('请填写药企报价');
          }
          if (this.taskPriceModel == 2 && (!el.tenantMinPrice || !el.tenantMaxPrice)) {
            throw new Error('请填写药企报价');
          }
          if (!el.tenantTaskPriceUnitGuid) {
            throw new Error('请填写药企报价单位');
          }

          //业务员报价、业务员报价单位
          detail.taskPrice = el.taskPrice;
          detail.taskPriceUnit = el.taskPriceUnit;
          detail.taskPriceUnitGuid = el.taskPriceUnitGuid;
          if (!el.taskPrice) {
            throw new Error('请填写业务员报价');
          }
          if (!el.taskPriceUnitGuid) {
            throw new Error('请填写业务员报价单位');
          }

          //标准量、标准量单位
          detail.taskTotal = null;
          detail.taskTotalUnit = el.taskTotalUnit;
          detail.taskTotalUnitGuid = el.taskTotalUnitGuid;
          if (!el.taskTotal && el.calcType == '固定量人均' && el.calcType == '系统计算') {
            throw new Error('请填写任务量');
          }
          if (!el.taskTotalUnitGuid) {
            throw new Error('请选择任务量单位');
          }
          if (el.isOpenMaxTask == 'Y') {
            if (el.maxTaskValue >= 0 && el.maxTaskValue <= 100) {
              detail.isOpenMaxTask = 'Y';
              detail.maxTaskValue = +el.maxTaskValue;
            } else {
              throw new Error('请填写正确上限百分比');
            }
          } else {
            detail.isOpenMaxTask = 'N';
            detail.maxTaskValue = 0;
          }
          detail.settleRule = el.settleRule;
          detail.settlePercent = el.settlePercent;

          if (!el.surveyLabelList?.length) {
            throw new Error('请选择标签');
          }

          detail.isAskClock = el.isAskClock;
          if (!el.isAskClock) {
            throw new Error('请选择是否打卡');
          }
          detail.isAskPhoto = el.isAskPhoto;
          if (!el.isAskPhoto) {
            throw new Error('请选择是否拍照');
          }
          detail.minAskPhoto = el.minAskPhoto;
          if (!el.minAskPhoto && el.isAskPhoto == '是') {
            throw new Error('请填写最少拍照数量');
          }
          detail.isAskUpload = el.isAskUpload;
          if (!el.isAskUpload) {
            throw new Error('请选择是否上传资料');
          }
          detail.minAskUpload = el.minAskUpload;
          if (!el.minAskUpload && el.isAskUpload == '是') {
            throw new Error('请填写最少上传资料数');
          }


          //任务要求
          detail.taskTag = el.taskTag && el.taskTag.length ? JSON.stringify(el.taskTag) : null;

          //药企任务文案 、药企工作要求 运营任务文案 运营工作文案
          detail.staffWorkNote = JSON.stringify(el.staffWorkNote.split('\n'));
          detail.staffTaskNote = el.staffTaskNote;
          detail.tenantWorkNote = el.tenantWorkNote;
          detail.tenantTaskNote = el.tenantTaskNote;
          if (!el.tenantTaskNote) {
            throw new Error('请至【更多内容编辑】中填写药企任务文案');
          }
          if (!el.staffTaskNote) {
            throw new Error('请至【更多内容编辑】中填写运营方任务文案');
          }
          if (!el.staffWorkNote) {
            throw new Error('请至【更多内容编辑】中填写运营方工作要求');
          }

          //客户区域
          var clientArea = [];

          if (el.clientAreaRadio == '本区域' || el.clientAreaRadio == '不限区域') {
            clientArea.push({
              name: el.clientAreaRadio,
              guid: '',
            });
          } else {
            if (!el.clientArea.length) {
              throw new Error('请选择客户区域');
            }
            el.clientArea.forEach((item, index) => {
              clientArea.push({
                name: el.clientAreaLabel[index],
                guid: item[1],
                provinceCode: item[0]
              });
            });
          }
          detail.clientArea = JSON.stringify(clientArea);
          //商品
          detail.goodsInfo = null;
          // var goodsInfo = [];
          // if (el.multipleSelection && el.multipleSelection.length != 0) {
          //   el.multipleSelection.forEach((i) => {
          //     goodsInfo.push({
          //       name: i.goodsName,
          //       guid: i.guid,
          //       goodsCount: Math.ceil(detail.taskTotal / el.multipleSelection.length),
          //       goodsUnit: i.unitStyle,
          //       goodsSpec: i.goodsSpec,
          //     });
          //   });
          //   detail.goodsInfo = goodsInfo.length == 0 ? null : JSON.stringify(goodsInfo);
          // } else {
          //   detail.goodsInfo = null;
          // }
          //任务要求
          detail.taskTag = el.taskTag && el.taskTag.length ? JSON.stringify(el.taskTag) : null;

          //任务图标
          detail.taskIcon = JSON.stringify(el.fileList);
          if (el.fileList && el.fileList.length == 0) {
            throw new Error('请至【更多内容编辑】中上传任务图标');
          }

          //规则
          taskTotalUnitList.forEach((item) => {
            if (item.guid == el.taskTotalUnitGuid) {
              detail.countRule = item.paramValue1;
            }
          });

          //任务总量类型
          detail.taskTotalType = el.calcType;


          detail.taskLabel = el.taskLabel && el.taskLabel.length ? JSON.stringify(el.taskLabel) : null

          detailParam.push(detail);
          this.detailParam = detailParam;
          this.organisationInfo = organisationInfo;
        });

        this.getTemplteName();
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
    },
    //存为项目模版
    saveTemplate() {
      var self = this;
      var tableDataII = this.$refs.templateConfig.tableData;
      tableDataII.forEach((item, index) => {
        if (item.parentTemplateDetailGuid || item.guid) {
          this.detailParam[index].parentTemplateDetailGuid = item.parentTemplateDetailGuid || item.guid;
          this.detailParam[index].parentTemplateDetailName = item.parentTemplateDetailName;
        }
      });
      var req = {
        serviceTenantGuid: this.serviceTenantGuid,//服务商
        serviceTenantName: this.serviceTenantName,
        organisationInfo: JSON.stringify(this.organisationInfo),
        tenantGuid: this.sendTenantGuid,//发布商
        tenantName: this.sendTenantName,
        isSuper: 'N',
        isUse: 'Y',
        templateName: this.newTemplateName,//模版名字
        detailList: this.detailParam,//模版明细
      };
      this.fullscreenLoading = true;
      var url = `/${serverConfig.msSalesPerformService}/task-set/template/edit`;
      self.api.postJson(url, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('模板保存成功');
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getDeliverName(res) {
      var list = JSON.parse(res);
      var strList = [];
      list.forEach((item) => {
        strList.push(item.name);
      });
      return strList.join('、');
    },
    chooseDepartmentPerson() {
      let departmentListII = this.departmentListII;
      let personList = [];
      departmentListII.forEach(i => {
        personList.push(i.guid);
      });
      this.$refs.chooseDepartment.open(personList);
    },
    //获取人员部门名称
    getDepartmentName(list) {
      if (typeof list == 'string') {
        list = JSON.parse(list);
      }
      let personArr = [];
      let personTip = '';
      let departmentArr = [];
      let departmentTip = '';
      let personNum = 0;
      let departmentNum = 0;
      if (list && list.length > 0) {
        list.forEach(i => {
          if (i.nodeType == 2) {
            personArr.push(i.organisationName || i.name);
            personNum = personNum + 1;
          } else {
            departmentNum = departmentNum + 1;
            departmentArr.push(i.organisationName || i.name);
          }
        });
      }
      personTip =
        personArr.length > 2
          ? personArr.splice(0, 2).join('、') + `等${personNum}个人`
          : personArr.splice(0, 2).join('、');
      departmentTip =
        departmentArr.length > 2
          ? departmentArr.splice(0, 2).join('、') + `等${departmentNum}个部门`
          : departmentArr.splice(0, 2).join('、');
      return departmentTip + (departmentTip && personTip ? '，' : '') + personTip;
    },
    //提交所选部门
    onDepartmentSelect([personGuidList, departmentData]) {
      let departmentListII = [];
      departmentData.forEach(item => {
        departmentListII.push({
          organisationName: item.name,
          guid: item.guid,
          nodeType: item.nodeType
        })
      })
      setTimeout(() => {
        this.$refs.templateConfig.getPlanCount();
      }, 200)

      let checkList = [];
      let overAgeOrg = [];

      departmentListII.forEach((item) => {
        checkList.push({
          objectGuid: item.guid,
          objectName: item.organisationName,
          objectType: item.nodeType == 1 ? '组织' : '人员'
        })
      });
      this.fullscreenLoading = true;
      //55岁拦截
      let req = {
        tenantGuid: this.sendTenantGuid,
        objectList: checkList
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-task/data/check-task-object`, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data) {
            this.openOrgAlert = true;
            this.openOrgAlertMsg = res.data.data;
            //获取超龄的人名单
            this.overAgeOrg = checkList;
            this.getOverAgeList();
          } else {
            this.overAgeOrg = [];
            this.openOrgAlert = false;
            this.openOrgAlertMsg = '';
            this.departmentListII = departmentListII;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      })
    },
    getTaskContentList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/content/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.taskContentList = res.data.data.records;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    search() {
      let self = this;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task-set/template/get-list`, this.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //选择委托方
    changeSendTenant(val) {
      let sendTenantList = this.sendTenantList;
      this.tenantName = val;
      sendTenantList.forEach((item) => {
        if (item.sendTenantName == this.tenantName) {
          this.area = [];
          this.year = '';
          this.month = '';
          this.timeRange = [];
          this.startTime = '';
          this.endTime = '';
          this.departmentList = [];
          this.departmentData = [];
          this.areaData = [];
          this.delList = [];
          this.filterText = '';
          this.areaII = [];
          this.departmentListII = [];
          this.departmentDataII = [];
          this.areaDataII = [];
          this.delListII = [];
          this.filterTextII = '';
          this.tableDataII = [];
          this.sendTenantGuid = item.sendTenantGuid;
          this.getOrganisation(item.sendTenantGuid);
          this.loadDatasetOptions();
        }
      });
      this.api.get('/ms-customer-service/tenant-expand/get-medicine-enterprise-detail?tenantGuid=' + this.sendTenantGuid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.taskPriceModel = res.data.data.taskPriceModel;
        }
      })
    },
    // FOUR-3010：数据集候选只看当前登录企业（单租户）——产品口径两端各维护各看各的
    // （药企在 ES 端维护自己的数据集，运营在协配端维护运营的）；FOUR-2996 的委托方+登录方
    // 双池口径由此反转回单值，后端 tenantGuids 为空自动走 tenantGuid eq，无需后端改动
    loadDatasetOptions() {
      this.api.postJson(`/${serverConfig.msSalesPerformService}/label-dataset/page-list`, {
        tenantGuid: localStorage.guid, dataStatus: 'N', pageIndex: 1, pageSize: 100,
      }).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.datasetOptions = res.data.data.records || [];
          this.ensureDatasetOption();
        }
      });
    },
    //获取组织
    getOrganisation(guid) {
      let self = this;
      let query = {
        tenantGuid: guid,
        // sendTenantGuid:localStorage.guid 加权限要
      }
      self.api
        .postJson(`/${serverConfig.msPersonnelService}/organisation/data/get-tree`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaData = res.data.data;
            this.treeData(self.areaData);
          } else {
            self.$message.error(res.data.msg);
            self.areaData = [];
          }
        });
    },
    //获取组织
    getOrganisationII(guid) {
      let self = this;
      let sendTenantGuid = guid;
      let tenantGuid = localStorage.guid;
      self.api
        .get(
          `/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail-from-servicetenant?tenantGuid=${tenantGuid}&sendTenantGuid=${sendTenantGuid}`,
        ).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.areaDataII = res.data.data;
          } else {
            self.$message.error(res.data.msg);
            self.areaDataII = [];
          }
        });
    },

    //查询人员
    getStaff(organisationGuid) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: 1,
        tenantGuid: this.sendTenantGuid,
        organisationGuid: organisationGuid,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, query).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (!res.data.data.records) {
            self.$message.error('该部门暂无人员,请谨慎选择!');
          }
        }
      });

    },
    treeData(areaData) {
      var self = this;
      const fn = (tree) => {
        tree.forEach(async (k) => {
          if (k.nodeType == 1) {
            k.disabled = true;
          }
          // 根据id获取人员数据,(注意转为树类型)
          if (k) {
            const isValid = (val) => {
              return val && val !== null && JSON.stringify(val) !== '[]';
            };
            // 将人员数据拼接到chilren里面
            if (k.children) {
              fn(k.children);
              k.children = [...k.children];
              // 有子元素，需要调用自身
            }
          }
        });
      };
      fn(areaData);
    },
    //部门弹框选择
    handleNodeClick1(data, checked, node) {
      if (checked == true) {//单选发布人员
        this.checkedId = data.guid;
        this.$refs.treeDep.setCheckedNodes([data]);
      }
      this.departmentList = this.$refs.treeDep.getCheckedNodes(true);
      this.departmentList.forEach(item => {
        item.staffName = item.name;
      })
      this.$forceUpdate();
    },
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleCheckChange(data, checked, node) {
      if (checked == true) {
        this.checkedId = data.guid;
        this.$refs.treeDep.setCheckedNodes([data]);
      }
    },
    nodeClick(data, checked, node) {
      this.checkedId = data.guid;
      this.$refs.treeDep.setCheckedNodes([data]);
    },
    //确定选择部门
    departmentSure() {
      this.filterText = '';
      this.departmentData = this.departmentList;
      this.visible3 = false;
    },
    //删除单个部门
    delDepartmentSingle(index) {
      if (this.disabled) return;
      this.departmentData.splice(index, 1);
      this.departmentList = this.departmentData;
      this.area.splice(index, 1);
      this.$refs.treeDep.setCheckedKeys([]);
      // this.departmentList.splice(index,1)
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.delList == null || self.delList.length == 0) {
        self.$message.error('请勾选成员！');
        return;
      }
      self.delList.forEach(function (j) {
        self.departmentList.forEach(function (i, index) {
          if (i.guid == j.guid) {
            self.departmentList.splice(index, 1);
            this.$refs.treeDep.setCheckedKeys([]);
          }
        });
      });
      self.delList.forEach(function (m) {
        self.area.forEach(function (n, idn) {
          if (JSON.parse(n).guid == m.guid) {
            self.area.splice(idn, 1);
          }
        });
      });
    },
    handleSelectionChange1(val) {
      let self = this;
      self.delList = val;
    },
    getApprovalList() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let token = localStorage.token;
      if (this.detail.bizApproveVO && this.$route.query.guid && this.detail.bizApproveVO.camundaInstanceId && this.detail.bizApproveVO.camundaDeploymentId) {
        this.iframeSh = true;
        this.iframeSrc = bpmnroute + '/iframeBpmn?processInstanceId=' + this.detail.bizApproveVO.camundaInstanceId + '&camundaDeploymentId=' + this.detail.bizApproveVO.camundaDeploymentId + '&token=' + token;
        return;
      }
      let req = {
        tenantGuid: localStorage.guid,
        flowType: '00012',
        staffGuid: userinfo.staffGuid
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/get-camunda-deployment-id`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (!res.data.data) {
            this.$message.error('没有找到规则,请先联系运营人员设置当前部门的流程规则');
            this.iframeSh = false;
          } else {
            this.iframeSh = true;
            this.iframeSrc = bpmnroute + '/iframeBpmnE?deploymentId=' + res.data.data + '&token=' + token;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //驳回提交
    toRejectSubmit() {
      if (this.approveSuggest == '') {
        this.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: this.detail.bizApproveVO.approveGuid,
        flowType: '00012',
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.staffGuid
      };
      this.fullscreenLoading = true;

      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success('驳回成功！');
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //通过
    toPassSubmit() {
      // 数据标注类型：确认人可修改内容（09-07 定稿），有修改先静默保存再走审批，无修改直接通过
      if (this.isLabelTask && this.labelConfigChanged()) {
        const errMsg = this.checkLabelForm();
        if (errMsg) {
          this.$message.error(errMsg);
          return;
        }
        this.submitLabelTask(1, true, () => this.doPassFlow());
        return;
      }
      this.doPassFlow();
    },
    //确认人修改比对（N7 行级化：表单快照+数据集 guid 集合双比对——数据集增删即视为配置变更；
    //旧包原文为空时视为未修改，避免审批人未改内容被硬拦截）
    labelConfigChanged() {
      if (!this.labelConfigRaw) return false;
      return this.labelConfigRaw !== this.buildLabelCompareSnapshot();
    },
    doPassFlow() {
      let query = {
        guid: this.detail.bizApproveVO.approveGuid,
        flowType: '00012',
        approveSuggest: this.approveSuggest,
        approveStaffGuid: this.staffGuid
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.$message.success('审批通过！');
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    //撤回
    toRevoke() {
      let self = this;
      this.$confirm('撤销后，该流程将不再进行审核，确定这样操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let query = {
          guid: this.detail.bizApproveVO.approveGuid,
          flowType: '00012',
          approveStaffGuid: this.staffGuid
        };
        self.fullscreenLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            self.$message.success('撤销成功！');
            self.$router.go(-1);
          } else {
            self.$message.error(res.data.msg);
          }
        });
      })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
  },
};
</script> 
<style >
.scheme-template .has-gutter .el-checkbox {
  display: none;
}
</style>
<style>
.service label {
  width: 80px !important;
}

.base-info label {
  width: 80px !important;
}
</style>
<style scoped>
.label-capacity-tip {
  color: #909399;
  line-height: 20px;
}
/* FOUR-3001：选择标签多行下拉（每行=下拉+删除，底部添加） */
.label-snapshot-rows {
  width: 100%;
  text-align: left;
}
.label-snapshot-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.label-snapshot-del {
  margin-left: 6px;
  flex-shrink: 0;
}
.title-memo{
  display:flex;
  align-items: center;

}
.title-memo .title-memo-title{
  display:flex;
  word-break: keep-all;
  flex-wrap: nowrap;
  margin-right:10px;

    
}
.title-memo-label{
  max-width:370px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow: ellipsis;
}
.content {
  background: #fff;
  font-size: 18px;
}

/deep/.el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

/deep/.el-form-item__content {
  margin-left: 20px !important;
}

.p16 {
  padding-top: 0;
  padding-left: 30px;
  padding-right: 30px;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.management-list {
  display: flex;
  align-items: center;
  margin-left: 24px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #606266;
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 0 !important;
}

.management-name {
  flex-shrink: 0;
  margin-right: 33px;
}

.designee {
  padding: 3px 10px 6px 10px;
  display: inline-block;
  /* border: 1px solid grey; */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 20px;
  margin-right: 10px;
  border-radius: 20px;
  background: #deefef;
  border: 0 none;
}

.input-item {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 25px;
}

.input-item .input-title {
  margin-right: 14px;
}

.title {
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  background: #fff;
  color: #323233;
  padding: 16px 0 10px 20px;
  margin-bottom: 0;
}


.template-box {
  width: 300px;
  float: left;
  border: 1px solid #dcdfe6;
  height: 34px;
  border-radius: 4px;
  line-height: 34px;
  text-align: left;
  text-indent: 10px;
  cursor: pointer;
  color: #606266;
}

.search-col {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.search-row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.search-name {
  width: 80px;
  word-break: keep-all;
}

.base-content {
  display: flex;
  font-size: 15px;
  padding: 20px 0;
}

.base-info {
  display: flex;
  align-items: center;
  margin-left: 23px;
  margin-bottom: 10px;
}

.base-info .base-title {
  word-break: keep-all;
  font-size: 14px;
  display: flex;
  color: rgb(96, 98, 102);
}

.depart-choose {
  width: 300px;
  height: 34px;
  border: 1px solid #dcdfe6;
  box-sizing: content-box;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-left: 34px;
}

.depart-choose span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.place-choose {
  padding-left: 10px;
  color: rgb(185, 185, 185);
}

.place-show {
  padding-left: 20px;
  padding-right: 20px;
}

.ai-tips {
  height: 26px;
  background: #FFEEE3;
  color: #FF741E;
  line-height: 26px;
  font-size: 13px;
  padding-left: 10px;
}

.download-btns {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  align-items: center;
}

.ai-item .lable {
  font-size: 14px;
  color: #232323;
}

.ai-item {
  margin-top: 20px;
}

.ai-item .value {
  color: #333;
  font-weight: 600;
  margin-left: 5px;
}

.ai-item .other1 {
  color: #333;
  font-weight: 600;
  margin-left: 5px;
}

.ai-item .other2 {
  color: #4fa1a4;
  text-decoration: underline;
  cursor: pointer;
}

.ai-item .ai-color {
  color: #4fa1a4;
  margin-left: 8px;
}


.download-btns .lable {
  font-size: 14px;
  color: #232323;
  flex: 1;
}

.download-btns .btns {
  flex: 1;
  display: flex;
  color: #323233;
  justify-content: flex-end;

}

.download-btns .btn1 {
  margin-right: 20px;
}

.download-btns .btn1,
.download-btns .btn2 {
  border: 1px solid #D9D9D9;
  padding: 6px;
  border-radius: 4px;
}

/deep/.ai-class .el-dialog--center .el-dialog__body {
  padding: 0 25px;
}

.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;

}

.flow {
  background: #fff;
  padding-left: 20px;
  margin-top: 4px;
  /* padding-right:20px; */
}

.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;

}

.header .back {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}

.header .task-title {
  flex: 1;
  font-weight: 500px;
}

.header .task-title span {
  font-size: 12px;
  color: #4fa1a4;
  margin-left: 5px;
  cursor: pointer;
}

.basic-conetent {
  background: #fff;
  margin-bottom: 4px;
}

.btn-groups {
  background: #fff;
}

.btn-groups .btn-common {
  width: 120px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.btn-border-green {
  background: #fff;
  color: #4fa1a4;
  border: 1px solid #4fa1a4;
}

.btn-border-gray {
  background: #f0f0f0;
  color: #323233;
  border: 1px solid #dcdee0;
}

.padding0 {
  padding-bottom: 0;
}

.approve-item-list {
  display: flex;
  background: #fff;
  margin-bottom: 4px;
  align-items: center;
  padding-bottom: 16px;
  position: relative;
}

.approve-item-list .item {
  display: flex;
  margin-left: 40px;
}

.approve-item-list img {
  position: absolute;
  right: 40px;
  width: 70px;
  bottom: 8px;
}

.contract-name {
  word-break: keep-all;
  margin-right: 25px;
}
.content-name {
  width: 280px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.task-model{
  text-align: left;
  color: red;
  padding-left: 118px;
  padding-bottom: 0px;
}
.content-main-box{
  height:534px;
  overflow:hidden;
}
/* ===== v26.3.3 数据标注配置区块 ===== */
.label-task-config {
  text-align: left; /* 抵御全局 #app text-align:center 波及 */
  padding: 0 0 10px 0;
}
.label-task-subtitle {
  font-size: 14px;
  font-weight: 600;
  color: #606266;
  margin: 6px 0 14px;
  padding-left: 12px;
}
.label-task-tip {
  font-size: 12px;
  font-weight: 400;
  color: #909399;
}
.label-task-more-btn {
  margin-left: 16px;
  font-weight: 400;
}
.label-task-modal {
  font-size: 12px;
  color: #909399;
  line-height: 20px;
}
</style>

